/*

  A17

  Doc: // Doc: https://code.area17.com/a17/fe-boilerplate/wikis/js-app

*/

// set up a master object
var A17 = window.A17 || {};

// HTML4 browser?
if (!A17.browserSpec || A17.browserSpec === 'html4') {
  // lets kill further JS execution of A17 js here
  throw new Error('HTML4');
}

// set up some objects within the master one, to hold my Helpers and behaviors
A17.Behaviors = {};
A17.Helpers = {};
A17.Functions = {};
A17.currentMediaQuery = 'large';
A17.activeBehaviors = {};

// set up and trigger looking for the behaviors on DOM ready
A17.onReady = function(){

  // sort out which media query we're using
  A17.currentMediaQuery = A17.Helpers.getCurrentMediaQuery();

  // go go go
  A17.Helpers.manageBehaviors();

  // on resize, check
  A17.Helpers.resized();
};

document.addEventListener('DOMContentLoaded', function(){
  A17.onReady();
});

// make console.log safe
if (typeof console === 'undefined') {
  window.console = {
    log: function () {
      return;
    }
  };
}

function serialize(form) {
  var field, s = [];
  if (typeof form == 'object' && form.nodeName == "FORM") {
    var len = form.elements.length;
    for (i=0; i<len; i++) {
      field = form.elements[i];
      if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
        if (field.type == 'select-multiple') {
          for (j=form.elements[i].options.length-1; j>=0; j--) {
            if(field.options[j].selected)
              s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[j].value);
          }
        } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
          s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
        }
      }
    }
  }
  return s.join('&').replace(/%20/g, '+');
}

A17.Helpers.escapeString = function(str) {
  // Doc: https://code.area17.com/mike/a17-js-helpers/wikis/A17-Helpers-escapeString

  if (typeof str === 'string') {
    var div = document.createElement('div');
    var text = document.createTextNode(str.replace(/<[^>]*>?/g, ''));
    div.appendChild(text);
    return encodeURIComponent(div.textContent);
  } else {
    return '';
  }
};

A17.Helpers.extend = function () {
  // Doc: https://code.area17.com/mike/a17-js-helpers/wikis/A17-Helpers-extend

  var obj = {};
  var i = 0;
  var argumentsLength = arguments.length;
  var key;

  for (; i < argumentsLength; i++) {
    for (key in arguments[i]) {
      if (arguments[i].hasOwnProperty(key)) {
        obj[key] = arguments[i][key];
      }
    }
  }

  return obj;

};

A17.Helpers.getCurrentMediaQuery = function() {
  // Doc: https://code.area17.com/mike/a17-js-helpers/wikis/A17-Helpers-getCurrentMediaQuery

  function parse(str) {
    return str.replace(/'/gi, '').replace(/"/gi, '');
  }

  if (window.opera) {
    return parse(window.getComputedStyle(document.body, ':after').getPropertyValue('content')) || 'large';
  } else if (window.getComputedStyle) {
    return parse(window.getComputedStyle(document.head, null).getPropertyValue('font-family')) || 'large';
  } else {
    return 'large';
  }
};

A17.Helpers.getIndex = function (node, nodeList) {
  // Doc: https://code.area17.com/mike/a17-js-helpers/wikis/A17-Helpers-getIndex

  var nodes = nodeList || node.parentNode.childNodes;
  var nodesLength = nodes.length;
  var n = 0;

  for (var i = 0; i < nodesLength; i++) {
    if (nodes[i] === node) {
      return n;
    }
    if (nodes[i].nodeType === 1) {
      n++;
    }
  }

  return -1;

};

// Doc: https://code.area17.com/mike/a17-js-helpers/wikis/A17-Helpers-keyCodes
A17.Helpers.keyCodes = {
  tab:   9,
  enter: 13,
  esc:   27,
  space: 32,
  left:  37,
  up:    38,
  right: 39,
  down:  40
};

A17.Helpers.manageBehaviors = function(options) {

  /*
    default init listens for event 'page:updated':
    A17.Helpers.manageBehaviors();

    init for pjax:
    A17.Helpers.manageBehaviors({pageUpdatedEventName:'pjax:end'});

    init for spf:
    A17.Helpers.manageBehaviors({pageUpdatedEventName:'spfdone'});
  */

  var idCounter = 0;
  var pageUpdatedEventName = (options && options.pageUpdatedEventName) ? options.pageUpdatedEventName : 'page:updated';

  function searchDomAndInitBehaviors(context) {
    if(context === undefined) {
      context = document;
    }
    var all = context.querySelectorAll('[data-behavior]');
    var i = -1;
    while (all[++i]) {
      var currentElement = all[i];

      // check to see if this element has had its behaviors already initialized by looking for _A17BehaviorsActive
      if (!currentElement._A17BehaviorsActive) {
        //console.log('initializing behaviors for:\n', currentElement);
        var behaviors = currentElement.getAttribute('data-behavior');
        var splittedBehaviors = behaviors.split(' ');
        for (var j = 0, k = splittedBehaviors.length; j < k; j++) {
          var ThisBehavior = A17.Behaviors[splittedBehaviors[j]];
          if(typeof ThisBehavior !== 'undefined') {
            try {
              // mark the element as having its behaviors initialized
              currentElement._A17BehaviorsActive = true;

              // add this instance to the activeBehaviors object so it can be interrogated if the page is updated later
              A17.activeBehaviors[idCounter] = {
                el: currentElement,
                behavior: new ThisBehavior(currentElement),
                name: splittedBehaviors[j]
              };

              try {
                A17.activeBehaviors[idCounter].behavior.init();
              } catch (err) {
                //console.log('failed to init behavior: ', A17.activeBehaviors[idCounter].name, '\n', err, A17.activeBehaviors[idCounter]);
              }

              idCounter++;
            } catch(err) {
              //console.log(err, currentElement, ThisBehavior);
            }
          }
        }
      } else {

        //console.log('behaviors already initialized for:\n', currentElement);
      }
    }
  }

  function pageUpdated() {
    // first check if anything was removed and clean up
    for (var activeBehaviorObj in A17.activeBehaviors) {
      if (A17.activeBehaviors.hasOwnProperty(activeBehaviorObj)) {
        var thisBehaviorObj = A17.activeBehaviors[activeBehaviorObj];

        // check if the element is still there
        if (!document.body.contains(thisBehaviorObj.el)) {
          //console.log('element no longer exists:\n', thisBehaviorObj.name, thisBehaviorObj);

          // trigger its destroy if its gone
          try {
            thisBehaviorObj.behavior.destroy();
            delete A17.activeBehaviors[activeBehaviorObj];
          } catch (err) {
            //console.log('failed to destroy behavior: ', thisBehaviorObj.name, '\n', err, thisBehaviorObj);
          }
        } else {

          //console.log('element still exists:\n', thisBehaviorObj.name, thisBehaviorObj);
        }
      }
    }

    // now look for new behaviors!
    searchDomAndInitBehaviors();
  }

  searchDomAndInitBehaviors();
  document.addEventListener(pageUpdatedEventName, pageUpdated);
  document.addEventListener('content:updated', function() {
    searchDomAndInitBehaviors( (event.data.el) ? event.data.el : '' );
  });
};

A17.Helpers.purgeProperties = function(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      delete obj[prop];
    }
  }
};

A17.Helpers.resized = function() {
  // Doc: https://code.area17.com/mike/a17-js-helpers/wikis/A17-Helpers-resized

  var resizeTimer;
  var mediaQueryUpdated = false;

  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // check media query
      var newMediaQuery = A17.Helpers.getCurrentMediaQuery();

      // is it different? if so, update global var
      if (A17.currentMediaQuery !== newMediaQuery) {
        A17.currentMediaQuery = newMediaQuery;
        mediaQueryUpdated = true;
      }

      // tell everything resized happened
      A17.Helpers.triggerCustomEvent(document, 'resized');

      // if media query changed, tell everything
      if (mediaQueryUpdated) {
        A17.Helpers.triggerCustomEvent(document, 'mediaQueryUpdated');
      }
    }, 250);
  });

};

A17.Helpers.triggerCustomEvent = function(el, type, data) {
  // Doc: https://code.area17.com/mike/a17-js-helpers/wikis/A17-Helpers-triggerCustomEvent

  var event = document.createEvent('HTMLEvents');
  event.initEvent(type, true, true);
  event.data = data || {};
  event.eventName = type;
  event.target = el;
  el.dispatchEvent(event);
};

A17.Behaviors.DummyBehavior = function(container) {

  /**
   * _handleClicks
   *
   *  @return {void}
   */
  function _handleClicks() {
    // action
  }

  /**
   * _handleResized
   *
   *  @return {void}
   */
  function _handleResized() {
    // action
  }

  /**
   * _init
   *
   *  @return {void}
   */
  function _init() {
    // add specific event handlers
    container.addEventListener('click', _handleClicks, false);
    document.addEventListener('resized', _handleResized);
  }

  this.destroy = function() {
    // remove specific event handlers
    container.removeEventListener('click', _handleClicks);
    document.removeEventListener('resized', _handleResized);

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

A17.Behaviors.EmbedResponsive = function(container) {

  /**
   * @param {object}
   * Cached versions of child elements
   */
  var _cachedElements = {
    embed: container.querySelector('iframe')
  };

  /**
   * _setRatio
   * check the width and height, work out the aspect ratio then set the
   * padding-bottom CSS value to the item.
   *
   *  @return {void}
   */
  function _setRatio() {

    var height = parseInt(_cachedElements.embed.height, 10);
    var width = _cachedElements.embed.width;
    var ratioPercentage = 1;

    // Assumption: A width of 100% means this doesn't need to be responsive
    if (width === '100%') {
      container.classList.remove('embed-responsive');
    } else {
      ratioPercentage = (height/parseInt(width, 10)) * 100;
      container.style.paddingBottom = ratioPercentage + '%';
      _cachedElements.embed.height = '100%';
      _cachedElements.embed.width = '100%';
    }
  }

  /**
   * _init
   *
   *  @return {void}
   */
  function _init() {
    _setRatio();
  }

  this.destroy = function() {
    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

/**
 * On submit we want to check to see if our form is
 * valid. `Valid` means, does it pass basic HTML5 rules
 * like `required` fields not being NULL or number fields
 * not exceeding their `max` value.
 *
 * If the form is not valid we don't submit it. Instead
 * we loop through the separate form fields showing/unshowing
 * the relevant inline error message.
 *
 * We also show a global error message which could sit at the top of the form or above the submit button
 *
 * Note: This JS could and should be cleaned-up.
 */

A17.Behaviors.FormValidate = function(container) {

  /**
   * @param {object}
   * Cached versions of child elements
   */
  var _cachedElements = {
    globalError: container.querySelector('.form-field__error--summary'),
    fieldsErrors: container.querySelectorAll('.form-field__error'),
    fieldsErrorsInline: container.querySelectorAll('.form-field__error:not(.form-field__error--summary)')
  };

  /**
   * @param {object}
   */
  var _classes = {
    hidden: 'hidden'
  };

  /**
   * _appendErrorList
   *
   * @param {array} $errors a lit of DOMElements containing our inline error messages
   * @return {void}
   */
  function _appendErrorList (errors) {

    var i;
    var errorsList = document.createElement('ul');
    var errorsListItem;
    var errorsListItemLink;

    if (errors.length > 0) {

      for (i = 0; i < errors.length; i++) {
        errorsListItem = document.createElement('li');
        errorsListItemLink = document.createElement('a');
        errorsListItemLink.href = '#' + errors[i].closest('.form-field').querySelector('input, select, textarea').id;
        errorsListItemLink.appendChild(document.createTextNode(errors[i].innerHTML));
        errorsListItem.appendChild(errorsListItemLink);

        errorsList.appendChild(errorsListItem);
      }

      if (_cachedElements.globalError) {
        _cachedElements.globalError.appendChild(errorsList);
      }

      // If there's only one error we probably don't need inline errors
      if (errors.length === 1) {
        _cachedElements.fieldsErrorsInline[0].classList.add(_classes.hidden);
        _cachedElements.fieldsErrorsInline[0].setAttribute('aria-hidden', 'true');
      }

    }

  }


  /**
   * _hideAllErrors
   *
   * @return {void}
   */
  function _hideAllErrors () {

    var errorList;

    // Hide top error summary
    if (_cachedElements.globalError) {
      _cachedElements.globalError.setAttribute('tabindex', '-1');
      _cachedElements.globalError.classList.add(_classes.hidden);
      _cachedElements.globalError.setAttribute('aria-hidden', 'true');

      errorList = _cachedElements.globalError.querySelector('ul');

      if (errorList) {
        _cachedElements.globalError.removeChild(errorList);
      }

    }

    // Hide inline errors
    for (i = 0; i < _cachedElements.fieldsErrors.length; i++){
      _cachedElements.fieldsErrors[i].classList.add(_classes.hidden);
      _cachedElements.fieldsErrors[i].setAttribute('aria-hidden', 'true');
    }

  }

  /**
   * _handleSubmit
   *
   * @param {object} event
   * @return {void}
   */
  function _handleSubmit(e) {

    var $field = null;
    var $fields = container.querySelectorAll('input, select, textarea');
    var $error = null;
    var i = 0;
    var $errors = [];

    // Assume we're valid and hide *all* errors
    _hideAllErrors();

    // Now check the form and if it isn't valid then show them
    if(container.checkValidity() !== true){

      // Unhide the main error message
      if (_cachedElements.globalError) {
        _cachedElements.globalError.classList.remove(_classes.hidden);
        _cachedElements.globalError.setAttribute('aria-hidden', 'false');

        // For a11y reasons - set the focus to the error summary so a screen-reader user
        // knows that an error has occurred
        _cachedElements.globalError.focus();
       }

      // Unhide inline error message for individual invalid fields
      for (i = 0; i < $fields.length; i++){

        if($fields[i].checkValidity() !== true){
          $field = $fields[i].closest('.form-field');
          $error = $field.querySelector('.form-field__error');

          $field.classList.add('form-field--error');

          if ($error) {

            $error.classList.remove(_classes.hidden);
            $error.setAttribute('aria-hidden', 'false');
            $errors.push($error);

            if (i === 0 && !_cachedElements.globalError) {
              $error.focus();
            }

          }

        }
      }

      _appendErrorList($errors);

      // Stop form from submitting
      if (e) {
        e.preventDefault();
      } else {
        return;
      }
    }

  }

  /**
   * _init
   *
   *  @return {void}
   */
  function _init() {
    // add specific event handlers
    container.addEventListener('submit', _handleSubmit, false);
  }

  this.destroy = function() {
    // remove specific event handlers
    container.removeEventListener('submit', _handleSubmit);

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

/**
 * InteractiveMap
 * When a map is found - replace the static map (you added a static map right?)
 * and convert it into a Google Map with the Google Maps API which we will
 * async load in if one isn't on the page already
 *
 * Expects the following HTML
 `
    <div data-behavior="InteractiveMap" class="" data-directions="DRIVING" data-latitude="LAT" data-longitude="LONG">
      <img
        src="https://maps.googleapis.com/maps/api/staticmap?center=LAT,LONG&zoom=4&size=740x480&amp;key=KEY"
        alt=""
        height="480"
        width="740"
     >
    </div>
 `
 */

A17.Behaviors.InteractiveMap = function(container) {

  /**
   * @param string
   * ID attribute of our added script
   */
  _scriptTagId = 'GoogleMapAPIScript';

  /**
   * @param string
   * Google Maps API key
   */
  _apiKey = 'AIzaSyB0AYFpwKKoAreACPxfvL52r3VRWYRdWko';

  /**
   * _loadAPI
   * Check to see if the API script is present and if not
   * add it to the DOM
   *
   * @return {void}
   */
  function _loadAPI() {

    var script = null;
    var scriptTag = document.getElementById(_scriptTagId);

    if(!scriptTag) {
      script = document.createElement('script');
      script.type = 'text/javascript';
      script.className = '';
      script.src = 'https://maps.google.com/maps/api/js?callback=GoogleMapsCallback&key=' + _apiKey;
      script.id = _scriptTagId;
      document.body.appendChild(script);
    } else {
      // Ok so the <script> tag is already on the page so now we need to know what its state is:
      // State 1:
      // The class isn't there then we assume another instance of this InteractiveMap has created the <script>
      // tag but it hasn't loaded yet from Google’s CDN so we will let that instance trigger the event when
      // State 2:
      // The class is there which means the <script> is in place and has loaded however, we assume that
      // the eventListener has not been added in this case e.g. maybe the page content has come from AJAX
      if (scriptTag.classList.contains('gmaps-api-loaded')) {
        A17.Helpers.triggerCustomEvent(document, scriptTagId);
      }
    }
  }

  /**
   * _replaceStaticMap
   *
   * We atart with an <img> tag that has a static map. Hide that and put an
   * interactive Google Map in there.
   *
   * @return {void}
   */
  function _replaceStaticMap() {

    var image = container.querySelector('img').setAttribute('style', 'display:none;');
    var gmapDOM = document.createElement('div');
    var gmap = '';
    var location = {
        lat: parseFloat(container.getAttribute('data-latitude')),
        lng: parseFloat(container.getAttribute('data-longitude'))
    };
    var map = null;
    var marker = null;
    var zoomLevel = 11;

    gmapDOM.className = 'gmap';
    container.appendChild(gmapDOM);

    gmap = container.querySelector('.gmap');

    map = new google.maps.Map(gmap, {
      zoom: zoomLevel,
      scrollwheel: false,
      center: location
    });

    // Show directions or just a simple marker?
    if (container.getAttribute('data-directions')) {
      _loadDirections(map, location);
    } else {
      marker = new google.maps.Marker({
        position: location,
        map: map
      });
    }

  }

  /**
   * _loadDirections
   *
   *  Display directions from the user's location to the destination
   *
   * @return {void}
   */
  function _loadDirections(map, destination) {

    var directionsDisplay = null;
    var zoomLevel = 11;
    var request = null;
    var directionsService = null;
    var userLocation = {lat: 41.85, lng: -87.65}; // TODO get location with HTML5

    directionsDisplay = new google.maps.DirectionsRenderer({
      map: map
    });

    // Set destination, origin and travel mode.
    request = {
      destination: destination,
      origin: userLocation,
      travelMode: container.getAttribute('data-directions')
    };

    // Pass the directions request to the directions service.
    directionsService = new google.maps.DirectionsService();
    directionsService.route(request, function(response, status) {
      if (status == 'OK') {
        // Display the route on the map.
        directionsDisplay.setDirections(response);
      }
    });

  }

  function _init() {
    _loadAPI();

    document.addEventListener(_scriptTagId, _replaceStaticMap, false);
  }

  this.destroy = function() {
    // remove specific event handlers - if any
    document.removeEventListener(_scriptTagId, _replaceStaticMap, false);

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };

  this.callback = function() {
    _replaceStaticMap();
  };
};

/**
 * GoogleMapsCallback
 *
 * As we are only loading the Google Maps API script when a module require it
 * We need a callback function(and Google Maps API requires it to be be global) to
 * determine if/when its script has loaded.
 *
 * So this callback adds some classes and triggers a custom event so our
 * InteractiveMap behavior knows to generate a map - without this we might get
 * an error when we call Google Map API's functions.
 *
 * @return {void}
 */
var GoogleMapsCallback = function () {
  var script = document.getElementById('GoogleMapAPIScript');

  script.classList.add('gmaps-api-loaded');
  A17.Helpers.triggerCustomEvent(document, 'GoogleMapAPIScript');
}

A17.Behaviors.ViewMore = function(container) {

  /**
   * @param {object}
   * The name for our sessionStorage key for main content
   */
  var _storageKeyContent = window.location.pathname + '--AJAX-CONTENT';

  /**
   * @param {object}
   * The name for our sessionStorage key for our button
   */
  var _storageKeyButton = window.location.pathname + '--AJAX-BUTTON';

  /**
   * @param {object}
   * Cached versions of child elements
   */
  var _cachedElements = {
    button: container.querySelector('a')
  };

  /**
   * @param {object}
   * Some wording we will use in places.
   */
  var _copy = {
    buttonActive: _cachedElements.button.innerHTML,
    buttonLoading: 'Loading...'
  };

  /**
   * @param {object}
   * Some classes we will use
   */
  var _classes = {
    loading: 'is-loading'
  };

  /**
   * @param {string}
   * The ID of the container we will load our AJAX response into and also
   * the element in the AJAX response that contains the data we want.
   */
  var _ajaxContainerId = container.getAttribute('data-viewmore-id');

  /**
   * _loadInDataFromStorage
   * Check to see if the user was on this page before and if so laod in all the
   * data that the user was previously looking at e.g. if the user clicked
   * View More twice, they are effectively on Page 3 of results so if they click
   * on one of those page 3 results then click back and return here then they
   * should see 3 page's of results.
   *
   * @return {void}
   */
  function _loadInDataFromStorage () {
    var list = document.querySelector('#' + _ajaxContainerId);
    var storedButton;
    var storedContent;

    if (typeof(Storage) === 'undefined') {
      return;
    }

    // Update content
    storedContent = sessionStorage.getItem(_storageKeyContent);

    if (storedContent) {
      list.innerHTML = storedContent;
    }

    // Update button: either update its content/values sor remove it based on
    // what page we need
    storedButton = sessionStorage.getItem(_storageKeyButton);

    if (storedButton) {
      container.innerHTML = storedButton;

      // Reset the cached button otherwise our events fail
      _cachedElements.button = container.querySelector('a');
    } else if (storedContent && !storedButton) {
      _removeButton();
    }

  }

  /**
   * _removeButton
   * Once we reach the last page lets kill the button (this DOM element)
   *
   * @return {void}
   */
  function _removeButton () {
    container.parentNode.removeChild(container);
  }

  /**
   * _updateButton
   * Update the the link/copy of our Load More button
   *
   * @param {string} content - our AJAX string (a chunk of HTML)
   * @return {void}
   */
  function _updateButton (content) {
    var temp = document.createElement('div');
    var button;

    temp.innerHTML = content;
    button = temp.querySelector('[data-behavior="ViewMore"] a');

    // If a button exists in the code then there must be another page of content
    // otherwise hide the button
    if (button) {
      _cachedElements.button.href = button.href;
      _resetButton();

      if (typeof(Storage) !== 'undefined') {
        sessionStorage.setItem(_storageKeyButton, container.innerHTML);
      }
    } else {
      _removeButton();

      if (typeof(Storage) !== 'undefined') {
        sessionStorage.removeItem(_storageKeyButton);
      }
    }
  }

  /**
   * _updateContent
   * Put our new AJAX content in place
   *
   * @param {string} content - our AJAX string (a chunk of HTML)
   * @return {void}
   */
  function _updateContent (content) {
    var temp = document.createElement('div');
    var list = document.querySelector('#' + _ajaxContainerId);
    var firstChild = '';
    var randomID = 'first-child-' + Math.floor(Math.random() * 2000);

    temp.innerHTML = content;

    // Just get the content we want so we don't end up with HTML like
    // <div id="_ajaxContainerId"><html><body>etc</body></html></div> OR
    // <div id="_ajaxContainerId"><div id="_ajaxContainerId"></div></div>
    content = temp.querySelector('#' + _ajaxContainerId);
    firstChild = content.querySelector('a');
    firstChild.setAttribute('data-ajax-id', randomID);

    list.innerHTML += content.innerHTML;

    // Cleanup - this might be over the top - but it can't hurt
    temp = null;
    content = null;

    list.classList.remove(_classes.loading);

    // Set focus to the new content so screen-readers can find the new stuff
    firstChild = list.querySelector('[data-ajax-id="' + randomID + '"]');
    firstChild.focus();

    // Place the content for the whole section into session storage
    if (typeof(Storage) !== 'undefined') {
      sessionStorage.setItem(_storageKeyContent, list.innerHTML);
    }
  }

  /**
   * _showLoadingMessage
   * Display a message for the user so they realise soemthing is happening in the background
   *
   * @return {void}
   */
  function _showLoadingMessage () {
    var list = document.querySelector('#' + _ajaxContainerId);

    // Indicate to the user that the content is loading in
    list.classList.add(_classes.loading);

    // Update the button
    _cachedElements.button.setAttribute('disabled', 'disabled');
    _cachedElements.button.innerHTML = _copy.buttonLoading;
  }

  /**
   * _resetButton
   * So the user realises they can click the Load More button again
   *
   * @return {void}
   */
  function _resetButton () {
    _cachedElements.button.removeAttribute('disabled');
    _cachedElements.button.innerHTML = _copy.buttonActive;
  }

  /**
   * _getDataViaAJAX
   *
   * @param {string} endpoint - our URL
   *
   * @return {void}
   */
  function _getDataViaAJAX(endpoint){

    var DONE = 4; // readyState 4 means the request is done.
    var OK = 200; // status 200 is a successful return.
    var xhr = new XMLHttpRequest();
    var extraParam = '&ajax=1';

    // append ?ajax or &ajax onto endpoint so Craft knows to send back a
    // special template for us
    if (endpoint.indexOf('?') === -1) {
      extraParam = extraParam.replace('&', '?');
    }

    endpoint = endpoint + extraParam;

    _showLoadingMessage();

    xhr.open('GET', endpoint);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('X_REQUESTED_WITH', 'XMLHttpRequest');
    xhr.setRequestHeader('X-Requested-By', 'XMLHttpRequest');
    xhr.send();

    xhr.onreadystatechange = function () {

      if (xhr.readyState === DONE) {
        if (xhr.status === OK) {
          _updateContent(xhr.responseText);
          _updateButton(xhr.responseText);
        } else {
          window.location = endpoint;
        }
      }
    };

    // XHR error = send user to linked URL
    if(!xhr) {
      window.location = endpoint;
    }
  }

  /**
   * _handleClicks
   *
   * @param {object} e - JavaScript click event
   * @return {void}
   */
  function _handleClicks(e) {
    var endpoint = _cachedElements.button.href;
    e.preventDefault();

    // AJAX call to load in new set of results
    _getDataViaAJAX(endpoint);
  }

  /**
   * _init
   *
   *  @return {void}
   */
  function _init() {
    _loadInDataFromStorage();
    container.addEventListener('click', _handleClicks, false);
  }

  this.destroy = function() {
    // remove specific event handlers
    container.removeEventListener('click', _handleClicks);

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

A17.Behaviors.Accordion = function(container) {
  // Doc: https://code.area17.com/mike/a17-js-helpers/wikis/A17-Behaviors-accordion

  /**
   * @param {object}
   * The tab DOM elements in this container.
   */
  var tabs = container.querySelectorAll('[role="tab"]');

  /**
   * @param {boolean}
   * The tab content e.g. the contne tthat is toggled by the tabs above.
   */
  var tabPanels = container.querySelectorAll('[role="tabpanel"]');

  /**
   * @param {boolean}
   * Attribute set via HTML. if true then only one tab is allowed to be open at once
   */
  var closeOthers = (container.getAttribute('data-accordion-close-others') === 'true');

  /**
   * @param {object}
   * The active tab DOM element
   */
  var openedItem;

  /**
   * @param {string}
   * A list of elements that can receive focus
   */
  var _focusString = 'a, area, object, input, select, textarea, button, iframe, [tabindex]';

  /*
   * _getContent(id)
   *
   * Returns the associated tabpanel content Node.
   *
   * @param (tab Node) The header Node that contains `aria-controls`
   *
   * @return Node
   *
  */
  function _getContent(tab) {
    if (!tab.content) {
      tab.content = container.querySelector('#'+tab.getAttribute('aria-controls'));
    }
    return tab.content;
  }

  /*
   * _isOpen(tab)
   *
   * @param (tab Node) Node you want to check if it is open.
   *
   * @return Boolean
   *
  */
  function _isOpen (tab) {
    return tab.getAttribute('aria-selected') === 'true';
  }

  /*
   * _calculateHeight()
   *
   * Thrashes the layout to calculate the height of each tabpanel and sets
   * data-height attribute in it.
   *
   * @return N/A
   *
  */
  function _calculateHeight () {
    var tabPanelsLength = tabPanels.length;
    for (var i = 0; i < tabPanelsLength; i++) {
      var item = tabPanels[i];

      // Initial height calculation
      item.style.display = 'block';
      item.style.maxHeight = 'initial';
      item.setAttribute('data-height', item.offsetHeight+'px');

      // Keep opened item if resizing
      if (item.getAttribute('aria-hidden') === 'false') {
        item.style.maxHeight = item.getAttribute('data-height');
      } else {
        item.style.maxHeight = '0px';
      }
    }
  }

  /*
   * _close(item)
   *
   * Hides the content of a given tab.
   *
   * @param (tab Node) The tab that should have it’s content hidden.
   *
   * @return N/A
   *
  */
  function _close (tab) {
    var content = _getContent(tab);

    tab.setAttribute('aria-selected', false);
    tab.setAttribute('aria-expanded', false);
    content.style.maxHeight = '0px';
    content.setAttribute('aria-hidden', true);

    openedItem = null;
  }

  /*
   * _open(item)
   *
   * Displays the content of a given tab.
   *
   * @param (tab Node) The tab that should have it's content displayed.
   *
   * @return N/A
   *
  */
  function _open (tab) {
    var content = _getContent(tab);

    if (closeOthers && openedItem) {
      _close(openedItem);
    }

    var tabsLength = tabPanels.length;
    for (var i = 0; i < tabsLength; i++) {
      tabs[i].getAttribute('tabindex', -1);
    }

    tab.setAttribute('aria-selected', true);
    tab.setAttribute('aria-expanded', true);
    tab.setAttribute('tabindex', 0);
    content.setAttribute('aria-hidden', false);
    content.style.maxHeight = content.getAttribute('data-height');

    openedItem = tab;
  }

  /*
   * _changeSelection(oldTab, newTab)
   *
   * Function that handles the blurring and focusing of a new tab
   *
   * @param(oldTab Node) The soon-to-be previous tab
   *
   * @param(newTab Node) The new tab to be focused
   *
   * @return N/A
   *
  */
  function _changeSelection(oldTab, newTab) {
    oldTab.setAttribute('tabindex', -1);
    oldTab.blur();

    newTab.focus();
    newTab.setAttribute('tabindex', 0);
  }

  /*
   * _selectNewTab(target, direction)
   *
   * Functions that handles the keyboard selection of a new tab.
   *
   * @param (target Node) Node from where the key event originated
   *
   * @param (direction string) Direction of the selection. Only accepts
   * 'prev' and 'next' string lowercase values.
   *
   * @return N/A
  */
  function _selectNewTab (target, direction) {
    var newTab,
      curNdx;

    curNdx = A17.Helpers.getIndex(target, tabs);

    switch(direction) {
      case 'prev':
        newTab = (curNdx === tabs.length-1) ? tabs[0] : tabs[curNdx+1];
        break;

      case 'next':
        newTab = (curNdx === 0) ? tabs[tabs.length-1] : tabs[curNdx-1];
        break;
    }

    _changeSelection(target, newTab);
  }

  /*
   * _handleClicks
   *
   * Handle clicks and trigger toggle if required.
   *
   * @param (e) the click event
   *
   * @return N/A
   *
  */
  function _handleClicks (e) {
    if (e.target.getAttribute('aria-controls')) {
      _toggleOpen(e.target);
    }
  }

  /*
   * _unsetFocussability
   *
   * Make all inactive tabs unfocussability. This is for accessibility purposes...
   * We don't want non-screen-reader-keybaord-using users to be tabbing to hidden tab content
   * because it's a waste of time for the and it is confusing. Imagine a hidden tabcontent block
   * with 50 links inside it and how annoying that would be to tab through.
   *
   * @return N/A
   *
  */
  function _unsetFocussability () {

    var i = 0;
    var ii = 0;
    var elements = '';

    for(i = 0; i < tabPanels.length; i++) {
      elements = tabPanels[i].querySelectorAll(_focusString);

      for (ii = 0; ii < elements.length; ii++) {
        elements[ii].setAttribute('tabindex', '-1');
      }
    }
  }

  /*
   * _setFocussability
   *
   * Make active tabs focusable elements focusaable again and vice versa.
   * Because we unset the ability to focus with _unsetFocussability above
   * we now need to allow user to tab to things when a tab is active/visible.
   *
   * @return N/A
   *
  */
  function _setFocussability (tab) {

    var i = 0;
    var content = _getContent(tab);
    var elements = content.querySelectorAll(_focusString);
    var isOpen = _isOpen(tab);

    if (elements) {
      for (i = 0; i < elements.length; i++) {
        if (isOpen === true) {
          elements[i].removeAttribute('tabindex');
        } else {
          elements[i].setAttribute('tabindex', '-1');
        }
      }
    }

  }

  /*
   * _toggleOpen
   *
   * Function that toggles a tab between opened and closed states.
   *
   * @param (tab Node) The tab you want to toggle.
   *
   * @return N/A
   *
  */
  function _toggleOpen (tab) {
    if (_isOpen(tab)) {
      _close(tab);
    } else {
      _open(tab);
    }
    _setFocussability(tab);
  }

  /*
   * _handleKeyDown (e)
   *
   * Function to handle the pressing of keys and preventing their default
   * action if they are part of the UI.
   *
   * @param (e Event) Javascript event triggered by listener
   *
   * @return N/A
   *
  */
  function _handleKeyDown (e) {
    if (e.target.getAttribute('aria-controls')) {
      switch(e.keyCode) {
        case A17.Helpers.keyCodes.down:
        case A17.Helpers.keyCodes.right:
          e.preventDefault();
          e.stopPropagation();
          _selectNewTab(e.target, 'prev');
          break;
        case A17.Helpers.keyCodes.up:
        case A17.Helpers.keyCodes.left:
          e.preventDefault();
          e.stopPropagation();
          _selectNewTab(e.target, 'next');
          break;
        case A17.Helpers.keyCodes.space:
        case A17.Helpers.keyCodes.enter:
          e.preventDefault();
          e.stopPropagation();
          _toggleOpen(e.target);
          break;
      }
    }
  }

  /*
   * _init()
   *
   * Function that kickstarts the accordion and binds the events.
   *
   * @return N/A
   *
  */
  function _init () {
    _calculateHeight();
    _unsetFocussability();
    container.addEventListener('keydown', _handleKeyDown, false);
    container.addEventListener('click', _handleClicks, false);
    document.addEventListener('resized', _calculateHeight);

    // after images have all loaded let's recalculate
    window.onload = function () {
      _calculateHeight();
    };

  }

  /*
   * destroy()
   *
   * Removes all the event listeners etc.
   *
   * @return N/A
   *
  */
  this.destroy = function() {
    // remove specific event handlers
    container.removeEventListener('keydown', _handleKeyDown);
    container.removeEventListener('click', _handleClicks);
    document.removeEventListener('resized', _calculateHeight);

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);

    // remove variables/functions of this behavior
    this._getContent = undefined;
    this._isOpen = undefined;
    this.__calculateHeight = undefined;
    this._open = undefined;
    this._close = undefined;
    this._changeSelection = undefined;
    this._selectNewTab = undefined;
    this._handleClicks = undefined;
    this._toggleOpen = undefined;
    this._handleKeyDown = undefined;
    this._init = undefined;
    this.tabs = undefined;
    this.tabPanels = undefined;
    this.closeOthers = undefined;
    this.openedItem = undefined;
  };

  /*
   * init()
   *
   * Public init, fires private _init
   *
   * @return N/A
   *
  */
  this.init = function() {
    _init();
  };
};

A17.Behaviors.header = function(container) {

  /**
   * @var {object}
   * Are we scrolling? in which direction?
   * use this in conjunction with requestAnimationFrame as opposed to
   * window.scroll(function(){}); as this performs better
   *
   * @return {int}
   */
  var _config = {
    // A cached scrollTop value
    top: window.scrolltop,

    // Are we scrolling up or down or not at all = false
    direction: 'down',

    // Class to be added/removed from <html> used as a CSS hook
    activeClass: 'header-unlocked',

    // Class to be added/removed from <html> used as a CSS hook
    activeClassHero: 'header-locked-hero',

    // Does this page have a hero?
    hasHero: document.documentElement.classList.contains('has-hero'),

    // set a value in px - this value will be the height of the header + Npx
    // after whch we will make the header white. This stops the header going white
    // whilst it is still in view and looking a little on first scroll
    headerOffset: 113
  };

  /**
   * @param {object}
   * Cached versions of child elements
   */
  var _cachedElements = {
    // All the `hero` elements on the page. We could have many. Later we
    // will want to work with the first one
    heroes: document.querySelectorAll('.o-hero, .o-exhibition-hero'),

    header: document.querySelectorAll('.g-header--target')
  };

  /**
   * checkScroll
   * Are we scrolling? in which direction?
   * use this in conjunction with requestAnimationFrame as opposed to
   * window.scroll(function(){}); as this performs better
   *
   * @return {void}
   */
  function _checkScroll() {

    var windowScrollTop = window.pageYOffset || parseInt(window.scrolltop, 10);

    // Work out if we are going down or up and set global values accordingly
    if(windowScrollTop > _config.top) {
      _config.direction = 'down';
    } else if(windowScrollTop < _config.top) {
      _config.direction = 'up';
    } else {
      _config.direction = false;
    }

    _config.top = windowScrollTop;

    // Work out when to (un/)lock the header
    if (_config.direction == 'up') {
      document.documentElement.classList.remove(_config.activeClass);
    } else if (_config.direction == 'down' && windowScrollTop > container.offsetHeight) {
      document.documentElement.classList.add(_config.activeClass);
    }


    // Ok if we have a hero on this page then we want the nav to have a specific class
    // when it’s out of view of the hero - WHY - because the design has it transparent which is
    // cool but then the header isn't very visible when it is `locked` in its scrolling up state.
    if (_config.hasHero && _cachedElements.heroes) {
      if ( windowScrollTop > _cachedElements.header[0].offsetHeight + _config.headerOffset) {
        document.documentElement.classList.add(_config.activeClassHero);
      } else {
        document.documentElement.classList.remove(_config.activeClassHero);
      }
    }

  }

  function _init() {

    // Automatically run this loop
    (function rafLoop(){
      _checkScroll();
      requestAnimationFrame(rafLoop, this);
    })();
  }

  this.destroy = function() {

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

A17.Behaviors.SocialSharingButtons = function(container) {
  // Doc: https://code.area17.com/mike/a17-js-helpers/wikis/A17-Behaviors-socialSharingButtons

  var socialWindowRef;

  function pageUrl() {
    return A17.Helpers.escapeString(container.getAttribute('data-share-url') || window.location.href);
  }

  function pageTitle() {
    return A17.Helpers.escapeString(document.title);
  }

  function buildFacebookURL() {
    return 'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl();
  }

  function buildGoogleURL() {
    return 'https://plus.google.com/share?' +
           'url=' + pageUrl();
  }

  function buildTwitterURL() {
    return 'https://twitter.com/intent/tweet?' +
           'url=' + pageUrl() +
           '&text=' + pageTitle() +
           '&via=' + (container.getAttribute('data-share-twitter-via') || '');
  }

  function buildPinterestrURL() {
    return 'http://pinterest.com/pin/create/button/?' +
           'url=' + pageUrl() +
           '&media=' + A17.Helpers.escapeString(document.getElementsByTagName('img')[0].getAttribute('src') || '') +
           '&description=' + pageTitle();
  }

  function openWindow(url, options) {
    if(!options) {
      options = {};
    }

    var width  = options.width || 575;
    var height = options.height || 400;
    var left   = (window.outerWidth  - width)  / 2;
    var top    = (window.outerHeight - height) / 2;
    var opts   = 'status=1' +
                 ',width='  + width  +
                 ',height=' + height +
                 ',top='    + top    +
                 ',left='   + left;
    if (socialWindowRef && !socialWindowRef.closed) {
      socialWindowRef.close();
    }
    setTimeout(function() {
      socialWindowRef = window.open(url, 'A17', opts);
      socialWindowRef.opener = null;
    }, 250);
  }

  function addListener(arr, func) {
    var arrLength = arr.length;
    for (var i = 0; i < arrLength; i++) {
      arr[i].addEventListener('click', func, false);
    }
  }

  function removeListener(arr, func) {
    var arrLength = arr.length;
    for (var i = 0; i < arrLength; i++) {
      arr[i].removeEventListener('click', func);
    }
  }

  // social networks
  function facebook(event) {
    event.preventDefault();
    var url = buildFacebookURL();
    openWindow(url);
  }

  function twitter(event) {
    event.preventDefault();
    var url = buildTwitterURL();
    openWindow(url, {height:253});
  }

  function googleplus(event) {
    event.preventDefault();
    var url = buildGoogleURL();
    openWindow(url, {width:515, height:505});
  }

  function pinterest(event) {
    event.preventDefault();
    var url = buildPinterestrURL();
    openWindow(url, {width:750, height:675});
  }

  function email(event) {
    event.preventDefault();
    openWindow(this.href);
  }

  function permalink(event) {
    var button = event.currentTarget;
    var input = button.closest('li').querySelector('[data-social-sharing-permalink-input]');
    var copiedCopy = button.getAttribute('data-copy-copied');
    var originalCopy = button.getAttribute('data-copy-original');

    event.preventDefault();
    input.select();

    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      input.blur();
      button.innerHTML = copiedCopy;

      // Reset the wording of the button after 3 seconds
      setTimeout(function() {
        button.innerHTML = originalCopy;
      }, 3000);

    } catch(error) {
      window.prompt('Copy to clipboard: Ctrl+C, Enter', URL);
    }
  }

  // init clicks
  this.init = function() {
    addListener(container.querySelectorAll('[data-social-sharing-facebook]'), facebook);
    addListener(container.querySelectorAll('[data-social-sharing-twitter]'), twitter);
    addListener(container.querySelectorAll('[data-social-sharing-googleplus]'), googleplus);
    addListener(container.querySelectorAll('[data-social-sharing-pinterest]'), pinterest);
    addListener(container.querySelectorAll('[data-social-sharing-email]'), email);
    addListener(container.querySelectorAll('[data-social-sharing-permalink]'), permalink);
  };

  // destroy
  this.destroy = function() {
    removeListener(container.querySelectorAll('[data-social-sharing-facebook]'), facebook);
    removeListener(container.querySelectorAll('[data-social-sharing-twitter]'), twitter);
    removeListener(container.querySelectorAll('[data-social-sharing-googleplus]'), googleplus);
    removeListener(container.querySelectorAll('[data-social-sharing-pinterest]'), pinterest);
    removeListener(container.querySelectorAll('[data-social-sharing-email]'), email);
    removeListener(container.querySelectorAll('[data-social-sharing-permalink]'), permalink);
  };
};

A17.Behaviors.Alert = function(container) {

  /**
   * @param {string}
   * We should have a cookie called 'alert' set by our CMS
   */
  var _cookie = document.cookie.replace(/(?:(?:^|.*;\s*)alert\s*\=\s*([^;]*).*$)|^.*$/, "$1");

  /**
   * @param {string}
   * the string/value we will look for to determine whether to show our alert or not
   */
  var _cookieUpdated = container.getAttribute('data-alert-updated');

  /**
   * @param {object}
   * Cached versions of child elements
   */
  var _cachedElements = {
    button: container.querySelector('.m-alert__btn')
  };

  /**
   * @param {string}
   * The CSS hook we will toggle on/off
   */
  var _inactiveClass = 'js-hide';

  /**
   * @var {boolean}
   * Our state. Is the share list visible or not?
   */
  var _active = true;

  /**
   * @param {object}
   * Lets us compare dates
   * Source: http://stackoverflow.com/questions/497790
   */
  var _dates = {
    convert: function(d) {
      // Converts the date in d to a date-object. The input can be:
      //   a date object: returned without modification
      //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
      //   a number     : Interpreted as number of milliseconds
      //                  since 1 Jan 1970 (a timestamp)
      //   a string     : Any format supported by the javascript engine, like
      //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
      //  an object     : Interpreted as an object with year, month and date
      //                  attributes.  **NOTE** month is 0-11.
      return (
        d.constructor === Date ? d :
        d.constructor === Array ? new Date(d[0], d[1], d[2]) :
        d.constructor === Number ? new Date(d) :
        d.constructor === String ? new Date(d) :
        typeof d === "object" ? new Date(d.year, d.month, d.date) :
        NaN
      );
    },
    compare: function(a, b) {
      // Compare two dates (could be of any type supported by the convert
      // function above) and returns:
      //  -1 : if a < b
      //   0 : if a = b
      //   1 : if a > b
      // NaN : if a or b is an illegal date
      // NOTE: The code inside isFinite does an assignment (=).
      return (
        isFinite(a = this.convert(a).valueOf()) &&
        isFinite(b = this.convert(b).valueOf()) ?
        (a > b) - (a < b) :
        NaN
      );
    }
  }

  /**
   * _padBody
   * Don't let the position:fixed alert sit over any content
   *
   * @return {void}
   */
  function _padBody() {
    document.documentElement.style.paddingBottom = container.offsetHeight + 'px';
  }

  /**
   * _unpadBody
   * Undo the work of _padBody
   *
   * @return {void}
   */
  function _unpadBody() {
    document.documentElement.style.paddingBottom = 0;
  }

  /**
   * _hide
   * Hide the nav
   * then set a cookie (lasting 3 days) that won't show the alert again.
   *
   * @return {void}
   */
  function _hide() {
    var d = new Date();
    var cookieExpiry = '';

    // hide/reset visual appearance
    container.classList.add(_inactiveClass);
    container.setAttribute('aria-hidden', 'true');
    _active = false;
    _unpadBody();

    // set cookie
    d.setTime(d.getTime() + 72*60*60*1000);
    cookieExpiry = d.toGMTString();
    _cookie = _cookieUpdated;
    document.cookie = 'alert=' + _cookie +'; expires=' + cookieExpiry + '; path=/';
  }

  /**
   * _isAlertOld
   * Work out if the alert is old or not by comparing the date on the alert itself
   * and the date in the cookie
   *
   * @return {boolean}
   */
  function _isAlertOld() {
    var alertIsOld = false;
    var cookieUpdatedDate = new Date(_cookieUpdated);
    var cookieSetDate = new Date(_cookie);
    var comparedDates = _dates.compare(cookieUpdatedDate, cookieSetDate);

    if (comparedDates === 0 || comparedDates === -1) {
      alertIsOld = true;
    }

    return alertIsOld;
  }

  /**
   * _init
   *
   *  @return {void}
   */
  function _init() {

    if (_isAlertOld()) {
      _hide();
    } else {
      _cachedElements.button.addEventListener('click', _hide, false);
      _padBody();
    }
  }

  this.destroy = function() {
    // remove specific event handlers
    _cachedElements.button.removeEventListener('click', _hide, false);

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

A17.Behaviors.HomeHeroClick = function(container) {

  /**
   * @param {object}
   * Cached versions of child elements
   */
  var _cachedElements = {
    // All the `hero` elements on the page.
    link: container.querySelector('.o-hero__title a'),
    image: container.querySelector('.o-hero__image')
  };

  /**
   * _goToLink
   *
   * @return {void}
   */
  function _goToLink () {
    window.location = _cachedElements.link.href;
  }

  /**
   * _init
   *
   *  @return {void}
   */
  function _init() {
    _cachedElements.image.addEventListener('click', _goToLink, false);
  }

  this.destroy = function() {

    _cachedElements.image.removeEventListener('click', _goToLink);

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

A17.Behaviors.HomeHeroHeight = function(container) {

  /**
   * @param {object}
   * Cached versions of elements
   */
  var _cachedElements = {
    image: container.querySelector('.o-hero__image'),
    header: document.querySelector('.g-header'),
    mobileBar: document.querySelector('.m-mobile-options'),
    firstHero: container.parentNode.querySelector(':first-child')
  };

  /**
   * _setHeight
   * Note: don't run on 'resize' because that will trigger the iOS Chrome bug
   * where it recalculates the height when the address bar vanishes on scroll.
   *
   * @return {void}
   */
  function _setHeight () {
    var height = screen.height;
    var mq = A17.Helpers.getCurrentMediaQuery();
    var isChrome = /CriOS/.test(navigator.userAgent);
    var addressBarHeight = 40;
    var isAndroid = /Android/.test(navigator.userAgent);
    var isIOS = /iPhone/.test(navigator.userAgent);
    var magicOffset = 50; // lets just add a little offset to line-up the first hero

    // don't run on shrunken desktop browsers
    if (!isAndroid && !isIOS) {
      return
    }

    // if it's Chrome lets take off the height of the address bar
    if (isChrome) {
      addressBarHeight = 20;
    }

    // only small screens needs this treatment
    // bigger screens respect 100vh better and don't the same <header> style
    if (mq === 'small' || mq === 'xsmall') {

      // our first hero needs to be slightly smaller to account for extra browser chrome
      // and the <header> being visible on load
      if (container == _cachedElements.firstHero) {
        height = height - (_cachedElements.header.offsetHeight + _cachedElements.mobileBar.offsetHeight - magicOffset);

        if (isChrome) {
          addressBarHeight = 70;
        } else {
          addressBarHeight = 87;
        }
      }

      height = height - addressBarHeight;

      container.style.minHeight = null;
      container.style.maxHeight = null;
      container.style.height = height + 'px';
      _cachedElements.image.style.height = height + 'px';
    } else {
      container.style.height = null;
      _cachedElements.image.style.height = null;
    }
  }

  /**
   * _init
   *
   *  @return {void}
   */
  function _init() {
    _setHeight();
    window.addEventListener('orientationchange', _setHeight, false);
  }

  this.destroy = function() {
    window.addEventListener('orientationchange', _setHeight);

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

A17.Behaviors.nav = function(container) {

  /**
   * @var {boolean}
   * Our state. Is the nav active (e.g. visible) or not?
   */
  var _active = false;

  /**
   * @var {object}
   * The CSS hook class we will add to the <html>
   */
  var _activeClass = 'nav-active';

  /**
   * @var {int}
   * The scrollTop position the user was at before the search was shown
   */
  var _userScrollTop = 0;

  /**
   * @var {object}
   * An object to house our touch in our touch-wipe.js class
   */
  var _touchObject;

  /**
   * @var {object}
   * List of items that we are caching to speed up selection later
   */
  var _cachedElements = {
    showButtons: document.querySelectorAll('[data-nav-show]'),
    hideButtons: document.querySelectorAll('[data-nav-hide]'),
    overlay: document.querySelector('[data-nav-overlay]'),
    header: document.querySelector('.g-header'),

    // Top level elements on the page which aren't the nav
    otherElements: document.querySelectorAll('header, .m-search-bar, main, footer, .skip-link'),

    // the search input box - we will need this if the users clicks the search icon to open the nav
    // searchInput: container.querySelector('input[type="search"]')
    searchInput: container.querySelector('.search'),
  };

  /**
   * @var {object}
   * Storage for the button that was clicked to show the nav
   * We will return user focus back here afterwards
   */
  var _clickedShowButton = null;

  /**
   * @var {object}
   * List of items in the container which can be receive focus
   */
  var _focusableEls = container.querySelectorAll('a, button, input');

  /**
   * _tabTrap
   * Trap tab focus inside the nav when it is active. This aids accessibility
   * because sighted keyboard users can otherwise tab into links/elements outside of
   * the nav which they cannot see which cna be confusing.
   * @see: https://hiddedevries.nl/en/blog/2017-01-29-using-javascript-to-trap-focus-in-an-element
   *
   * @param {object} e
   *
   * @return {void}
   */
  function _tabTrap(e) {

    var firstFocusableEl = _focusableEls[0];
    var lastFocusableEl = _focusableEls[(_focusableEls.length - 1)];
    var KEYCODE_TAB = 9;
    var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

    // If the nav isn't visible OR the user isn't tabbing then stop checking
    if (!isTabPressed || _active !== true){
      return;
    }

    // We have determined that user is tabbing but are they
    // A: holding down the shift key to tab backwards or B: tabbing forwards (no shift key)
    if (e.shiftKey){
      if (document.activeElement === firstFocusableEl){
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableEl){
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }

  }

  /**
   * _tabToggle
   * Don't allow the nav to be tabbed to if it is not visible.
   * Elements with a tabindex="-1" attribute/value combo cannot receive focus
   * so we add/remove this attribute/value when necessary
   *
   * @return {void}
   */
  function _tabToggle() {

    var i = 0;

    for (i = 0; i < _focusableEls.length; i++) {
      if (_active === true) {
        _focusableEls[i].removeAttribute('tabindex');
      } else {
        _focusableEls[i].setAttribute('tabindex', '-1');
      }
    }

  }

  /**
   * _focusFirstNavElement
   * Find the first focussable element in the active nav and
   * set focus to it for accessibility. If the user has clicked the search icon
   * then focus the nav instead
   * @param {object} currentTarget
   *
   * @return {void}
   */
  function _focusFirstNavElement(currentTarget) {

    var firstFocusableEl = _focusableEls[0];

    if (currentTarget.getAttribute('aria-labelledby') == 'search-open-title') {
      _cachedElements.searchInput.focus();
    } else {
      firstFocusableEl.focus();
    }
  }

  /**
   * markButtonsAsNotExpanded
   * Set all the buttons that open the menu to have the correct aria-expanded attribute
   *
   * @return {void}
   */
  function _markButtonsAsNotExpanded() {

    var i;

    for (i = 0; i < _cachedElements.showButtons.length; i++) {
      _cachedElements.showButtons[i].setAttribute('aria-expanded', 'false');
    }

  }

  /**
   * _toggle
   * Allow (or don't allow) screen-readers to read the rest of the page's content
   * @param {boolean} hide
   *
   * @return {void}
   */
  function _toggleOtherElementsFromSR(hide) {

    var i;

    for (i = 0; i < _cachedElements.otherElements.length; i++) {
      _cachedElements.otherElements[i].setAttribute('aria-hidden', hide);
    }

  }

  /**
   * _swipeClose
   * use the touch-wipe plugin to detect a swipe from left to right
   *
   * @return {void}
   */
  function _swipeClose() {

    _touchObject = touchwipe(container, {
      wipeRight: function() {
        _hide();
      },
      min_move_x: 50,
      min_move_y: 20,
      preventDefaultEvents: true
    });

  }

  /**
   * _show
   * Show the nav
   * @param {object} e - the clicked item
   *
   * @return {void}
   */
  function _show(e) {
    var currentTarget = e.currentTarget;
    var transitionEnd;
    var i;

    e.preventDefault();

    if (!document.getElementById('a17').style.top) {
      _userScrollTop = window.scrollY || document.documentElement.scrollTop;
      
      if (A17.currentMediaQuery == 'small' || A17.currentMediaQuery == 'xsmall') {
        document.getElementById('a17').style.top = '-' + (_userScrollTop - _cachedElements.header.offsetHeight) + 'px';
      } else {
        document.getElementById('a17').style.top = '-' + _userScrollTop + 'px';
      }
    } else {
      _userScrollTop = null;
    }

    document.documentElement.classList.add(_activeClass);

    _active = true;
    _clickedShowButton = e.currentTarget;

    // Let nav items be tabbed to
    _tabToggle();

    // Mark open buttons as expanded
    for (i = 0; i < _cachedElements.showButtons.length; i++) {
      _cachedElements.showButtons[i].setAttribute('aria-expanded', 'true');
    }

    // Let screen-readers read out the contents if visible
    container.setAttribute('aria-hidden', 'false');

    // Do not screen-readers to read the rest of the page's content
    _toggleOtherElementsFromSR('true');

    // Trap the user’s tabbing inside the active nav
    container.addEventListener('keydown', _tabTrap, false);

    // Set focus to the nav - so the user can tab through the
    // Reasons = Browsers :/
    // 1 only do this after the transition ends or Safari freaks out
    // 2 remove the eventListener otherwise IE11 goes nuts
    container.addEventListener('transitionend', transitionEnd = function(event) {
      container.removeEventListener('transitionend', transitionEnd);
      _focusFirstNavElement(currentTarget);
    }, {once: true });


    // Swipe
    _swipeClose();

  }

  /**
   * _hide
   * Hide the nav
   *
   * @return {void}
   */
  function _hide() {

    document.documentElement.classList.remove(_activeClass);

    _active = false;

    // Prevent nav items being tabbed to
    _tabToggle();

    _markButtonsAsNotExpanded();

    // Don't let screen-readers read out the contents if hidden
    container.setAttribute('aria-hidden', 'true');

    // Allow screen-readers to read the rest of the page's content
    _toggleOtherElementsFromSR('false');

    // Let user tab around again
    container.removeEventListener('keydown', _tabTrap);

    // Set focus back to the first show nav button
    _clickedShowButton.focus();

    // Swipe
    _touchObject.unbind();

    // Send the user back where they where before they clicked to show the search bar
    document.getElementsByTagName('body')[0].scrollTop = _userScrollTop || 0;
    document.documentElement.scrollTop = _userScrollTop || 0;

    if (Number.isInteger(_userScrollTop)) {
      document.getElementById('a17').style.top = '';
    }
    
    _userScrollTop = 0;

  }

  /**
   * _backgroundClick
   * If the nav is showing and we are *not* clicking anywhere on the nav itself then
   * @return {void}
   */
  function _backgroundClick(e) {

    if (_active === true && e.target === _cachedElements.overlay){
      _hide();
    }

  }

  /**
   * _escPress
   * If the nav is showing and the user clicks the Esc key then we want to hide the menu
   *
   * @return {void}
   */
  function _escPress(e) {

    var e = e || window.event;
    var escKey = 27;

    if (e.keyCode === escKey && _active === true){
      _hide();
    }

  }

  /**
   * _safari9Fix
   * test to see if we are on Safari 8 or 9 and then remove the transition from
   * the container as this causes a weird bug on close where entire page jumps
   * left after _hide() runs
   *
   * @return {void}
   */
  function _safari9Fix() {

    var isSafari = navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    var isSafari9 = false;
    var isSafari8 = false;

    if(isSafari) {
      isSafari9 = navigator.userAgent.match(/Version\/9/);
      isSafari8 = navigator.userAgent.match(/Version\/8/);

      if (isSafari9 || isSafari8) {
        container.style.webkitTransition = 'none';
      }
    }
  }

  /**
   * _init
   * Set-up
   *
   * @return {void}
   */
  function _init() {

    var i = 0;

    _safari9Fix();

    _tabToggle();

    // Don't let screen-readers read out the contents if hidden
    container.setAttribute('aria-hidden', 'true');

    _markButtonsAsNotExpanded();

    // Set some event listeners

    // Show nav on click of button
    for (i = 0; i < _cachedElements.showButtons.length; i++) {
      _cachedElements.showButtons[i].addEventListener('click', _show, false);
    }

    // Hide nav on click of hide button
    for (i = 0; i < _cachedElements.hideButtons.length; i++) {
      _cachedElements.hideButtons[i].addEventListener('click', _hide, false);
    }

    // Hide on Esc key
    window.addEventListener('keydown', _escPress, false);

    // Hide on click background
    document.getElementById('a17').addEventListener('click', _backgroundClick, false);

  }

  this.destroy = function() {

    var i = 0;

    // remove specific event handlers
    for (i = 0; i < _cachedElements.showButtons.length; i++) {
      _cachedElements.showButtons[i].removeEventListener('click', _show);
    }

    for (i = 0; i < _cachedElements.hideButtons.length; i++) {
      _cachedElements.hideButtons[i].removeEventListener('click', _hide);
    }

    document.removeEventListener('keypress', _escPress);
    container.removeEventListener('keydown', _tabToggle);
    document.getElementById('a17').removeEventListener('click', _backgroundClick);

    // Swipe
    _touchObject.unbind();

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  // Exposed functions
  this.init = function() {
    _init();
  };
};

A17.Behaviors.Newsletter = function(container) {

  /**
   * @var {object}
   * Cached versions of child elements
   */
  _cachedElements = {
    success: container.querySelector('.m-newsletter__success'),
    loading: container.querySelector('.m-newsletter__loading'),
    signup: container.querySelector('.m-newsletter__signup')
  };

  /**
   * _showSection
   * Make sure a given section is shown (make sure it's `visible` to screen-readers too)
   * @param {obejct} section - the block of code in the DOM to be shown
   *
   * @return {void}
   */
  function _showSection(section) {
    section.setAttribute('aria-hidden', 'false');
    section.classList.remove('hidden');
  }

  /**
   * _hideSection
   * Make sure a given section is hidden (make sure it's `invisible` to screen-readers too)
   * @param {obejct} section - the block of code in the DOM to be hidden
   *
   * @return {void}
   */
  function _hideSection(section) {
    section.setAttribute('aria-hidden', 'true');
    section.classList.add('hidden');
  }

  /**
   * _sendAJAXCall
   *
   * @return {void}
   */
  function _sendAJAXCall() {

    var DONE = 4; // readyState 4 means the request is done.
    var OK = 200; // status 200 is a successful return.
    var xhr = new XMLHttpRequest();
    var data = serialize(container);
    var formAction = container.getAttribute('action');

    xhr.open('POST', formAction);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('HTTP_X_REQUESTED_WITH', 'XMLHttpRequest');
    xhr.setRequestHeader('X-Requested-By', 'XMLHttpRequest');
    xhr.send(data);

    xhr.onreadystatechange = function () {

      _hideSection(_cachedElements.loading);

      if (xhr.readyState === DONE) {
        if (xhr.status === OK) {
          _showSection(_cachedElements.success);
          _hideSection(_cachedElements.signup);
        } else {
          _showSection(_cachedElements.signup);
        }
      }
    };

  }

  /**
   * _handleSubmit
   * Trigger an AJAX call on submit BUT only if the form is valid. If the form
   * isn't (HTML5) valid then our other global behavior 'FormValidate' will
   * help us with this - so don't worry abut error handling here.
   * @param {object} e - JavaScript event
   *
   * @return {void}
   */
  function _handleSubmit(e) {

    if(container.checkValidity() === true){

      e.preventDefault();

      _showSection(_cachedElements.loading);
      _hideSection(_cachedElements.signup);

      // Send AJAX call to back-end
      _sendAJAXCall();

    }
  }

  /**
   * _init
   *
   * @return {void}
   */
  function _init() {
    // add specific event handlers
    container.addEventListener('submit', _handleSubmit, false);
  }

  this.destroy = function() {
    // remove specific event handlers
    container.removeEventListener('submit', _handleSubmit);

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

/**
 * Product Gallery
 * @uses Flickity v2.0.5 http://flickity.metafizzy.co/
 */
A17.Behaviors.ProductGallery = function(container) {

  /**
   * @var {object}
   * Placeholder for our Flickity slider
   */
  var _flkty = null;

  /**
   * @var {object}
   * The thumbnails (well the parent <li>) of them
   * We need this so we can only init if there are multiples
   */
  var _thumbs = container.querySelectorAll('.m-product__media');

  /**
   * @var {object}
   * Our options for our slider
   * @see http://flickity.metafizzy.co/options.html
   */
  var _flktyOptions = {
    cellAlign: 'left',
    contain: true,
    imagesLoaded: true,
    prevNextButtons: false
  };

  function _init() {

    if(_thumbs.length > 1) {
      _flkty = new Flickity(container, _flktyOptions);
    }
  }

  this.destroy = function() {
    // remove specific event handlers
    _flkty.destroy();

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

A17.Behaviors.SearchBar = function(container) {

  /**
   * @var {boolean}
   * Our state. Is the nav active (e.g. visible) or not?
   */
  var _active = false;

  /**
   * @var {object}
   * The CSS hook class we will add to the <html>
   */
  var _activeClass = 'search-bar-active';

  /**
   * @var {int}
   * The scrollTop position the user was at before the search was shown
   */
  var _userScrollTop = 0;

  /**
   * @var {object}
   * List of items that we are caching to speed up selection later
   */
  var _cachedElements = {
    showButtons: document.querySelectorAll('[data-search-show]'),
    hideButtons: document.querySelectorAll('[data-search-hide]'),
    overlay: document.querySelector('[data-search-overlay]'),
    header: document.querySelector('.g-header'),

    // Top level elements on the page which aren't the nav
    otherElements: document.querySelectorAll('nav, main, footer, .skip-link'),

    // the search input box - we will need this if the users clicks the search icon to open the nav
    // searchInput: container.querySelector('input[type="search"]')
    searchInput: container.querySelector('.search'),
  };

  /**
   * @var {object}
   * Storage for the button that was clicked to show the nav
   * We will return user focus back here afterwards
   */
  var _clickedShowButton = null;

  /**
   * @var {object}
   * List of items in the container which can be receive focus
   */
  var _focusableEls = container.querySelectorAll('a, button, input');

  /**
   * _tabTrap
   * Trap tab focus inside the nav when it is active. This aids accessibility
   * because sighted keyboard users can otherwise tab into links/elements outside of
   * the nav which they cannot see which cna be confusing.
   * @see: https://hiddedevries.nl/en/blog/2017-01-29-using-javascript-to-trap-focus-in-an-element
   *
   * @param {object} e
   *
   * @return {void}
   */
  function _tabTrap(e) {

    var firstFocusableEl = _focusableEls[0];
    var lastFocusableEl = _focusableEls[(_focusableEls.length - 1)];
    var KEYCODE_TAB = 9;
    var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

    // If the nav isn't visible OR the user isn't tabbing then stop checking
    if (!isTabPressed || _active !== true){
      return;
    }

    // We have determined that user is tabbing but are they
    // A: holding down the shift key to tab backwards or B: tabbing forwards (no shift key)
    if (e.shiftKey){
      if (document.activeElement === firstFocusableEl){
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableEl){
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }

  }

  /**
   * _tabToggle
   * Don't allow the nav to be tabbed to if it is not visible.
   * Elements with a tabindex="-1" attribute/value combo cannot receive focus
   * so we add/remove this attribute/value when necessary
   *
   * @return {void}
   */
  function _tabToggle() {

    var i = 0;

    for (i = 0; i < _focusableEls.length; i++) {
      if (_active === true) {
        _focusableEls[i].removeAttribute('tabindex');
      } else {
        _focusableEls[i].setAttribute('tabindex', '-1');
      }
    }

  }

  /**
   * _focusInput
   *
   * @return {void}
   */
  function _focusInput() {
    _cachedElements.searchInput.focus();
  }

  /**
   * markButtonsAsNotExpanded
   * Set all the buttons that open the menu to have the correct aria-expanded attribute
   *
   * @return {void}
   */
  function _markButtonsAsNotExpanded() {

    var i;

    for (i = 0; i < _cachedElements.showButtons.length; i++) {
      _cachedElements.showButtons[i].setAttribute('aria-expanded', 'false');
    }

  }

  /**
   * _toggle
   * Allow (or don't allow) screen-readers to read the rest of the page's content
   * @param {boolean} hide
   *
   * @return {void}
   */
  function _toggleOtherElementsFromSR(hide) {

    var i;

    for (i = 0; i < _cachedElements.otherElements.length; i++) {
      _cachedElements.otherElements[i].setAttribute('aria-hidden', hide);
    }

  }

  /**
   * _show
   * Show the nav
   * @param {object} e - the clicked item
   *
   * @return {void}
   */
  function _show(e) {

    var currentTarget = e.currentTarget;
    var transitionEnd;

    e.preventDefault();

    // _userScrollTop = document.getElementsByTagName('body')[0].scrollTop;
    _userScrollTop = window.scrollY;

    document.getElementById('a17').style.top = '-' + _userScrollTop + 'px';


    // if (A17.currentMediaQuery == 'small' || A17.currentMediaQuery == 'xsmall') {
    //   document.getElementById('a17').style.top = '-' + (_userScrollTop - _cachedElements.header.offsetHeight) + 'px';
    // } else {
    //   document.getElementById('a17').style.top = '-' + _userScrollTop + 'px';
    // }

    document.documentElement.classList.add(_activeClass);

    _active = true;
    _clickedShowButton = e.currentTarget;

    // Let nav items be tabbed to
    _tabToggle();

    // Mark open buttons as expanded
    for (i = 0; i < _cachedElements.showButtons.length; i++) {
      _cachedElements.showButtons[i].setAttribute('aria-expanded', 'true');
    }

    // Let screen-readers read out the contents if visible
    container.setAttribute('aria-hidden', 'false');

    // Do not screen-readers to read the rest of the page's content
    _toggleOtherElementsFromSR('true');

    // Trap the user’s tabbing inside the active nav
    container.addEventListener('keydown', _tabTrap, false);

    _focusInput();

  }

  /**
   * _hide
   * Hide the nav
   *
   * @return {void}
   */
  function _hide() {

    document.documentElement.classList.remove(_activeClass);

    _active = false;

    // Prevent nav items being tabbed to
    _tabToggle();

    _markButtonsAsNotExpanded();

    // Don't let screen-readers read out the contents if hidden
    container.setAttribute('aria-hidden', 'true');

    // Allow screen-readers to read the rest of the page's content
    _toggleOtherElementsFromSR('false');

    // Let user tab around again
    container.removeEventListener('keydown', _tabTrap);

    // Set focus back to the first show nav button
    _clickedShowButton.focus();

    // Send the suer back where they where before they clicked to show the search bar
    window.scrollTo(0, _userScrollTop);

    document.getElementById('a17').style.top = '';
    _userScrollTop = 0;

  }

  /**
   * _backgroundClick
   * If the nav is showing and we are *not* clicking anywhere on the nav itself then
   * @return {void}
   */
  function _backgroundClick(e) {

    if (_active === true && e.target === _cachedElements.overlay){
      _hide();
    }

  }

  /**
   * _escPress
   * If the nav is showing and the user clicks the Esc key then we want to hide the menu
   *
   * @return {void}
   */
  function _escPress(e) {

    var e = e || window.event;
    var escKey = 27;

    if (e.keyCode === escKey && _active === true){
      _hide();
    }

  }

  /**
   * _init
   * Set-up
   *
   * @return {void}
   */
  function _init() {

    var i = 0;

    _tabToggle();

    // Don't let screen-readers read out the contents if hidden
    container.setAttribute('aria-hidden', 'true');

    _markButtonsAsNotExpanded();

    // Set some event listeners

    // Show nav on click of button
    for (i = 0; i < _cachedElements.showButtons.length; i++) {
      _cachedElements.showButtons[i].addEventListener('click', _show, false);
    }

    // Hide nav on click of hide button
    for (i = 0; i < _cachedElements.hideButtons.length; i++) {
      _cachedElements.hideButtons[i].addEventListener('click', _hide, false);
    }

    // Hide on Esc key
    window.addEventListener('keydown', _escPress, false);

    // Hide on click background
    document.getElementById('a17').addEventListener('click', _backgroundClick, false);

  }

  this.destroy = function() {

    var i = 0;

    // remove specific event handlers
    for (i = 0; i < _cachedElements.showButtons.length; i++) {
      _cachedElements.showButtons[i].removeEventListener('click', _show);
    }

    for (i = 0; i < _cachedElements.hideButtons.length; i++) {
      _cachedElements.hideButtons[i].removeEventListener('click', _hide);
    }

    document.removeEventListener('keypress', _escPress);
    container.removeEventListener('keydown', _tabToggle);
    document.getElementById('a17').removeEventListener('click', _backgroundClick);

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  // Exposed functions
  this.init = function() {
    _init();
  };
};

A17.Behaviors.Share = function(container) {

  /**
   * @param {object}
   * Cached versions of child elements
   */
  var _cachedElements = {
    list: container.querySelector('[data-behavior="SocialSharingButtons"]'),
    button: container.querySelector('.m-share__btn')
  };

  /**
   * @param {string}
   * The CSS hook we will toggle on/off
   */
  var _inactiveClass = 'js-hide';

  /**
   * @var {boolean}
   * Our state. Is the share list visible or not?
   */
  var _active = false;

  /**
   * _toggle
   * Show/Hide the child sharing list items on click
   *
   * @return {void}
   */
  function _toggle() {

    if (_active === false) {
      _show();
    } else {
      _hide();
    }

  }

  /**
   * _show
   * Show the nav
   *
   * @return {void}
   */
  function _show(e) {
    var focussableElements = _cachedElements.list.querySelectorAll('a, button, input');

    _cachedElements.list.classList.remove(_inactiveClass);
    _active = true;

    _cachedElements.button.setAttribute('aria-expanded', 'true');

    // Send focus to the list
    if (focussableElements) {
      focussableElements[0].focus();
    }
  }

  /**
   * _hide
   * Hide the nav
   *
   * @return {void}
   */
  function _hide() {
    _cachedElements.list.classList.add(_inactiveClass);
    _active = false;

    _cachedElements.button.setAttribute('aria-expanded', 'false');

    // Return focus to the toggle button
    _cachedElements.button.focus();
  }

  /**
   * _backgroundClick
   * If the nav is showing and we are *not* clicking anywhere on the nav itself then
   * @return {void}
   */
  function _backgroundClick(e) {

    if (_active === true && e.target.closest('[data-behavior="Share"]') !== container){
      _hide();
    }

  }

  /**
   * _escPress
   * If the nav is showing and the user clicks the Esc key then we want to hide the menu
   *
   * @return {void}
   */
  function _escPress(e) {

    var e = e || window.event;
    var escKey = 27;

    if (e.keyCode === escKey && _active === true){
      _hide();
    }

  }

  /**
   * init
   * Attach specific event handlers
   * @return {void}
   */
  function _init() {

    // Click button to show.hide
    _cachedElements.button.addEventListener('click', _toggle, false);

    // Hide on Esc key
    window.addEventListener('keydown', _escPress, false);

    // Hide on click background
    document.getElementById('a17').addEventListener('click', _backgroundClick, false);
  }

  this.destroy = function() {
    // remove specific event handlers
    _cachedElements.button.removeEventListener('click', _toggle);

    // Hide on Esc key
    window.removeEventListener('keydown', _escPress, false);

    // Hide on click background
    document.getElementById('a17').removeEventListener('click', _backgroundClick, false);

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

A17.Behaviors.ProductGalleryThumbs = function(container) {

  /**
   * @param {object}
   * Cached versions of child elements
   */
  var _cachedElements = {
    thumbs: container.querySelectorAll('.m-product-gallery__thumb'),
    mainImage: container.querySelector('.m-product__gallery--shopify img')
  };

  /**
   * @param {string}
   */
  var _activeClass = 'm-product-gallery__thumb--active';

  /**
   * _setActive
   *
   * @param {object} item
   *
   *  @return {void}
   */
  function _setActive(item) {

    var i = 0;

    for (i = 0; i < _cachedElements.thumbs.length; i++) {
      _cachedElements.thumbs[i].classList.remove(_activeClass);
    }

    item.classList.add(_activeClass);

  }

  /**
   * _swapImage
   *
   * @param {object} event
   *
   * @return {void}
   */
  function _swapImage(event) {
    event.preventDefault();

    _cachedElements.mainImage.src = event.currentTarget.href;
    _setActive(event.currentTarget.closest('.m-product-gallery__thumb'));

  }

  /**
   * _init
   *
   *  @return {void}
   */
  function _init() {

    var i = 0;

    if (!container.querySelector('.' + _activeClass)) {
      _setActive(_cachedElements.thumbs[0]);
    }

    // Change image
    for (i = 0; i < _cachedElements.thumbs.length; i++) {
      _cachedElements.thumbs[i].querySelector('a').addEventListener('click', _swapImage, false);
    }

  }

  this.destroy = function() {
    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);

    // Turn off change image
    for (i = 0; i < _cachedElements.thumbs.length; i++) {
      _cachedElements.thumbs[i].querySelector('a').removeEventListener('click', _swapImage);
    }
  };

  this.init = function() {
    _init();
  };
};

/**
 * Slider Gallery
 * @uses Flickity v2.0.5 http://flickity.metafizzy.co/
 */

A17.Behaviors.SliderGallery = function(container) {

  /**
   * @var {object}
   * Placeholder for our Flickity slider
   */
  var _flkty = null;

  /**
   * @var {object}
   * Our options for our slider
   * @see http://flickity.metafizzy.co/options.html
   */
  var _flktyOptions = {
    cellAlign: 'left',
    cellSelector: '.m-card-artwork',
    contain: true,
    imagesLoaded: true,
    percentPosition: false,
    prevNextButtons: false,
    pageDots: false
  };

  function _init() {
    _flkty = new Flickity(container, _flktyOptions);
  }

  this.destroy = function() {
    // remove specific event handlers
    _flkty.destroy();

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

/**
 * Tabs
 * @uses Flickity v2.0.5 http://flickity.metafizzy.co/
 */

A17.Behaviors.Tabs = function(container) {

  /**
   * @var {object}
   * Placeholder for our Flickity slider
   */
  var _flkty = null;

  /**
   * @var {object}
   * Our options for our slider
   * @see http://flickity.metafizzy.co/options.html
   */
  var _flktyOptions = {
    cellAlign: 'center',
    cellSelector: '.m-tabs__item',
    contain: false,
    imagesLoaded: false,
    pageDots: false,
    percentPosition: false,
    prevNextButtons: false,
    resize: true
  };

  /**
   * @param {object}
   * Cached versions of child elements
   */
  var _cachedElements = {
    list: container.querySelector('.m-tabs__list'),
    listItems: container.querySelectorAll('.m-tabs__item'),
    selectedLink: container.querySelector('.m-tabs__link[aria-current="true"]')
  };

  /**
   * _getCurrentIndex
   * Work out in the index of the currently selected menu item
   * @return {int}
   */
  function _getCurrentIndex () {
    var activeLi = null;
    var activeIndex = 0;

    if (_cachedElements.selectedLink){
      activeLi = _cachedElements.selectedLink.parentNode;
      activeIndex = [].slice.call(activeLi.parentNode.children).indexOf(activeLi);
    }

    return activeIndex;
  }

  /**
   * _resetFlickity
   * Hmm, ooookay. Something in flickity causes it to incorrectly set the widths
   * unless we trigger a resize event. Then once the event has been triggered
   * we have to recalcuate the widths and kill Flickity if we do not need it
   * e.g. if all listItems fit on the screen in a row
   * Use a setTimeout because Flickity doesn't provide a callback after its
   * initialised in the version we are using here.
   *
   * @return {void}
   */
  function _resetFlickity () {

    if(_flkty !== null) {

      window.dispatchEvent(new Event('resize'));

      setTimeout(function(){

        var listWidth = 0;
        var i = 0;

        for(i = 0; i < _cachedElements.listItems.length; i++) {
          listWidth = listWidth + _cachedElements.listItems[i].offsetWidth
        }

        if (_cachedElements.list.offsetWidth > listWidth) {
          _flkty.destroy();
        }

      }, 100);

    }

  }

  /**
   * init
   *
   * @return {void}
   */
  function _init() {

    // Only set Flickity *if* we need to e.g. if all listItems fit do not fit on the screen in a row
    if (_cachedElements.list.offsetWidth >= document.documentElement.clientWidth) {
      _flktyOptions.initialIndex = _getCurrentIndex();

      if (_cachedElements.listItems.length > 1 && _cachedElements.listItems.length === (_flktyOptions.initialIndex + 1)) {
        _flktyOptions.cellAlign = 'right';
      } else if (_cachedElements.listItems.length > 1 && _flktyOptions.initialIndex === 0) {
        _flktyOptions.cellAlign = 'left';
      }

      _flkty = new Flickity(_cachedElements.list, _flktyOptions);
      _resetFlickity();
    }

  }

  /**
   * destroy
   *
   * @return {void}
   */
  this.destroy = function() {
    // remove specific event handlers
    if (_flkty) {
      _flkty.destroy();
    }

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

A17.Behaviors.TagList = function(container) {

  /**
   * @param {object}
   * Cached versions of child elements
   */
  var _cachedElements = {
    list: container.querySelector('ul'),
    select: container.querySelector('select')
  };

  /**
   * _submit
   * Go to the option value
   *
   * @return {void}
   */
  function _submit(e) {
    window.location = _cachedElements.select.value;
  }

  /**
   * init
   *
   * @return {void}
   */
  function _init() {
    // Change select
    _cachedElements.select.addEventListener('change', _submit, false);
  }

  /**
   * destroy
   *
   * @return {void}
   */
  this.destroy = function() {
    // remove specific event handlers
    // Change select
    _cachedElements.select.removeEventListener('change', _submit, false);

    // remove properties of this behavior
    A17.Helpers.purgeProperties(this);
  };

  this.init = function() {
    _init();
  };
};

(function (ElementProto) {
	if (typeof ElementProto.matches !== 'function') {
		ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
			var element = this;
			var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
			var index = 0;

			while (elements[index] && elements[index] !== element) {
				++index;
			}

			return Boolean(elements[index]);
		};
	}

	if (typeof ElementProto.closest !== 'function') {
		ElementProto.closest = function closest(selector) {
			var element = this;

			while (element && element.nodeType === 1) {
				if (element.matches(selector)) {
					return element;
				}

				element = element.parentNode;
			}

			return null;
		};
	}
})(window.Element.prototype);

/*!
 * Flickity PACKAGED v2.0.5
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * http://flickity.metafizzy.co
 * Copyright 2016 Metafizzy
 */

/**
 * Bridget makes jQuery widgets
 * v2.0.1
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /* globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'jquery-bridget/jquery-bridget',[ 'jquery' ], function( jQuery ) {
      return factory( window, jQuery );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('jquery')
    );
  } else {
    // browser global
    window.jQueryBridget = factory(
      window,
      window.jQuery
    );
  }

}( window, function factory( window, jQuery ) {
'use strict';

// ----- utils ----- //

var arraySlice = Array.prototype.slice;

// helper function for logging errors
// $.error breaks jQuery chaining
var console = window.console;
var logError = typeof console == 'undefined' ? function() {} :
  function( message ) {
    console.error( message );
  };

// ----- jQueryBridget ----- //

function jQueryBridget( namespace, PluginClass, $ ) {
  $ = $ || jQuery || window.jQuery;
  if ( !$ ) {
    return;
  }

  // add option method -> $().plugin('option', {...})
  if ( !PluginClass.prototype.option ) {
    // option setter
    PluginClass.prototype.option = function( opts ) {
      // bail out if not an object
      if ( !$.isPlainObject( opts ) ){
        return;
      }
      this.options = $.extend( true, this.options, opts );
    };
  }

  // make jQuery plugin
  $.fn[ namespace ] = function( arg0 /*, arg1 */ ) {
    if ( typeof arg0 == 'string' ) {
      // method call $().plugin( 'methodName', { options } )
      // shift arguments by 1
      var args = arraySlice.call( arguments, 1 );
      return methodCall( this, arg0, args );
    }
    // just $().plugin({ options })
    plainCall( this, arg0 );
    return this;
  };

  // $().plugin('methodName')
  function methodCall( $elems, methodName, args ) {
    var returnValue;
    var pluginMethodStr = '$().' + namespace + '("' + methodName + '")';

    $elems.each( function( i, elem ) {
      // get instance
      var instance = $.data( elem, namespace );
      if ( !instance ) {
        logError( namespace + ' not initialized. Cannot call methods, i.e. ' +
          pluginMethodStr );
        return;
      }

      var method = instance[ methodName ];
      if ( !method || methodName.charAt(0) == '_' ) {
        logError( pluginMethodStr + ' is not a valid method' );
        return;
      }

      // apply method, get return value
      var value = method.apply( instance, args );
      // set return value if value is returned, use only first value
      returnValue = returnValue === undefined ? value : returnValue;
    });

    return returnValue !== undefined ? returnValue : $elems;
  }

  function plainCall( $elems, options ) {
    $elems.each( function( i, elem ) {
      var instance = $.data( elem, namespace );
      if ( instance ) {
        // set options & init
        instance.option( options );
        instance._init();
      } else {
        // initialize new instance
        instance = new PluginClass( elem, options );
        $.data( elem, namespace, instance );
      }
    });
  }

  updateJQuery( $ );

}

// ----- updateJQuery ----- //

// set $.bridget for v1 backwards compatibility
function updateJQuery( $ ) {
  if ( !$ || ( $ && $.bridget ) ) {
    return;
  }
  $.bridget = jQueryBridget;
}

updateJQuery( jQuery || window.jQuery );

// -----  ----- //

return jQueryBridget;

}));

/**
 * EvEmitter v1.0.3
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( 'ev-emitter/ev-emitter',factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {



function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var i = 0;
  var listener = listeners[i];
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  while ( listener ) {
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
    // get next listener
    i += isOnce ? 0 : 1;
    listener = listeners[i];
  }

  return this;
};

return EvEmitter;

}));

/*!
 * getSize v2.0.2
 * measure size of elements
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */
/*global define: false, module: false, console: false */

( function( window, factory ) {
  'use strict';

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'get-size/get-size',[],function() {
      return factory();
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See http://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * WebKit measures the outer-width on style.width on border-box elems
   * IE & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );

  getSize.isBoxSizeOuter = isBoxSizeOuter = getStyleSize( style.width ) == 200;
  body.removeChild( div );

}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});

/**
 * matchesSelector v2.0.1
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'desandro-matches-selector/matches-selector',factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));

/**
 * Fizzy UI utils v2.0.3
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'fizzy-ui-utils/utils',[
      'desandro-matches-selector/matches-selector'
    ], function( matchesSelector ) {
      return factory( window, matchesSelector );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {



var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  var ary = [];
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( obj && typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    if ( timeout ) {
      clearTimeout( timeout );
    }
    var args = arguments;

    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold || 100 );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));

// Flickity.Cell
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/cell',[
      'get-size/get-size'
    ], function( getSize ) {
      return factory( window, getSize );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('get-size')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Cell = factory(
      window,
      window.getSize
    );
  }

}( window, function factory( window, getSize ) {



function Cell( elem, parent ) {
  this.element = elem;
  this.parent = parent;

  this.create();
}

var proto = Cell.prototype;

proto.create = function() {
  this.element.style.position = 'absolute';
  this.x = 0;
  this.shift = 0;
};

proto.destroy = function() {
  // reset style
  this.element.style.position = '';
  var side = this.parent.originSide;
  this.element.style[ side ] = '';
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

proto.setPosition = function( x ) {
  this.x = x;
  this.updateTarget();
  this.renderPosition( x );
};

// setDefaultTarget v1 method, backwards compatibility, remove in v3
proto.updateTarget = proto.setDefaultTarget = function() {
  var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
  this.target = this.x + this.size[ marginProperty ] +
    this.size.width * this.parent.cellAlign;
};

proto.renderPosition = function( x ) {
  // render position of cell with in slider
  var side = this.parent.originSide;
  this.element.style[ side ] = this.parent.getPositionValue( x );
};

/**
 * @param {Integer} factor - 0, 1, or -1
**/
proto.wrapShift = function( shift ) {
  this.shift = shift;
  this.renderPosition( this.x + this.parent.slideableWidth * shift );
};

proto.remove = function() {
  this.element.parentNode.removeChild( this.element );
};

return Cell;

}));

// slide
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/slide',factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Slide = factory();
  }

}( window, function factory() {
'use strict';

function Slide( parent ) {
  this.parent = parent;
  this.isOriginLeft = parent.originSide == 'left';
  this.cells = [];
  this.outerWidth = 0;
  this.height = 0;
}

var proto = Slide.prototype;

proto.addCell = function( cell ) {
  this.cells.push( cell );
  this.outerWidth += cell.size.outerWidth;
  this.height = Math.max( cell.size.outerHeight, this.height );
  // first cell stuff
  if ( this.cells.length == 1 ) {
    this.x = cell.x; // x comes from first cell
    var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
    this.firstMargin = cell.size[ beginMargin ];
  }
};

proto.updateTarget = function() {
  var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
  var lastCell = this.getLastCell();
  var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
  var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
  this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.select = function() {
  this.changeSelectedClass('add');
};

proto.unselect = function() {
  this.changeSelectedClass('remove');
};

proto.changeSelectedClass = function( method ) {
  this.cells.forEach( function( cell ) {
    cell.element.classList[ method ]('is-selected');
  });
};

proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  });
};

return Slide;

}));

// animate
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/animate',[
      'fizzy-ui-utils/utils'
    ], function( utils ) {
      return factory( window, utils );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.animatePrototype = factory(
      window,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, utils ) {



// -------------------------- requestAnimationFrame -------------------------- //

// get rAF, prefixed, if present
var requestAnimationFrame = window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame;

// fallback to setTimeout
var lastTime = 0;
if ( !requestAnimationFrame )  {
  requestAnimationFrame = function( callback ) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max( 0, 16 - ( currTime - lastTime ) );
    var id = setTimeout( callback, timeToCall );
    lastTime = currTime + timeToCall;
    return id;
  };
}

// -------------------------- animate -------------------------- //

var proto = {};

proto.startAnimation = function() {
  if ( this.isAnimating ) {
    return;
  }

  this.isAnimating = true;
  this.restingFrames = 0;
  this.animate();
};

proto.animate = function() {
  this.applyDragForce();
  this.applySelectedAttraction();

  var previousX = this.x;

  this.integratePhysics();
  this.positionSlider();
  this.settle( previousX );
  // animate next frame
  if ( this.isAnimating ) {
    var _this = this;
    requestAnimationFrame( function animateFrame() {
      _this.animate();
    });
  }
};


var transformProperty = ( function () {
  var style = document.documentElement.style;
  if ( typeof style.transform == 'string' ) {
    return 'transform';
  }
  return 'WebkitTransform';
})();

proto.positionSlider = function() {
  var x = this.x;
  // wrap position around
  if ( this.options.wrapAround && this.cells.length > 1 ) {
    x = utils.modulo( x, this.slideableWidth );
    x = x - this.slideableWidth;
    this.shiftWrapCells( x );
  }

  x = x + this.cursorPosition;
  // reverse if right-to-left and using transform
  x = this.options.rightToLeft && transformProperty ? -x : x;
  var value = this.getPositionValue( x );
  // use 3D tranforms for hardware acceleration on iOS
  // but use 2D when settled, for better font-rendering
  this.slider.style[ transformProperty ] = this.isAnimating ?
    'translate3d(' + value + ',0,0)' : 'translateX(' + value + ')';

  // scroll event
  var firstSlide = this.slides[0];
  if ( firstSlide ) {
    var positionX = -this.x - firstSlide.target;
    var progress = positionX / this.slidesWidth;
    this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
  }
};

proto.positionSliderAtSelected = function() {
  if ( !this.cells.length ) {
    return;
  }
  this.x = -this.selectedSlide.target;
  this.positionSlider();
};

proto.getPositionValue = function( position ) {
  if ( this.options.percentPosition ) {
    // percent position, round to 2 digits, like 12.34%
    return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 )+ '%';
  } else {
    // pixel positioning
    return Math.round( position ) + 'px';
  }
};

proto.settle = function( previousX ) {
  // keep track of frames where x hasn't moved
  if ( !this.isPointerDown && Math.round( this.x * 100 ) == Math.round( previousX * 100 ) ) {
    this.restingFrames++;
  }
  // stop animating if resting for 3 or more frames
  if ( this.restingFrames > 2 ) {
    this.isAnimating = false;
    delete this.isFreeScrolling;
    // render position with translateX when settled
    this.positionSlider();
    this.dispatchEvent('settle');
  }
};

proto.shiftWrapCells = function( x ) {
  // shift before cells
  var beforeGap = this.cursorPosition + x;
  this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
  // shift after cells
  var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
  this._shiftCells( this.afterShiftCells, afterGap, 1 );
};

proto._shiftCells = function( cells, gap, shift ) {
  for ( var i=0; i < cells.length; i++ ) {
    var cell = cells[i];
    var cellShift = gap > 0 ? shift : 0;
    cell.wrapShift( cellShift );
    gap -= cell.size.outerWidth;
  }
};

proto._unshiftCells = function( cells ) {
  if ( !cells || !cells.length ) {
    return;
  }
  for ( var i=0; i < cells.length; i++ ) {
    cells[i].wrapShift( 0 );
  }
};

// -------------------------- physics -------------------------- //

proto.integratePhysics = function() {
  this.x += this.velocity;
  this.velocity *= this.getFrictionFactor();
};

proto.applyForce = function( force ) {
  this.velocity += force;
};

proto.getFrictionFactor = function() {
  return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
};

proto.getRestingPosition = function() {
  // my thanks to Steven Wittens, who simplified this math greatly
  return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
};

proto.applyDragForce = function() {
  if ( !this.isPointerDown ) {
    return;
  }
  // change the position to drag position by applying force
  var dragVelocity = this.dragX - this.x;
  var dragForce = dragVelocity - this.velocity;
  this.applyForce( dragForce );
};

proto.applySelectedAttraction = function() {
  // do not attract if pointer down or no cells
  if ( this.isPointerDown || this.isFreeScrolling || !this.cells.length ) {
    return;
  }
  var distance = this.selectedSlide.target * -1 - this.x;
  var force = distance * this.options.selectedAttraction;
  this.applyForce( force );
};

return proto;

}));

// Flickity main
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/flickity',[
      'ev-emitter/ev-emitter',
      'get-size/get-size',
      'fizzy-ui-utils/utils',
      './cell',
      './slide',
      './animate'
    ], function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
      return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter'),
      require('get-size'),
      require('fizzy-ui-utils'),
      require('./cell'),
      require('./slide'),
      require('./animate')
    );
  } else {
    // browser global
    var _Flickity = window.Flickity;

    window.Flickity = factory(
      window,
      window.EvEmitter,
      window.getSize,
      window.fizzyUIUtils,
      _Flickity.Cell,
      _Flickity.Slide,
      _Flickity.animatePrototype
    );
  }

}( window, function factory( window, EvEmitter, getSize,
  utils, Cell, Slide, animatePrototype ) {



// vars
var jQuery = window.jQuery;
var getComputedStyle = window.getComputedStyle;
var console = window.console;

function moveElements( elems, toElem ) {
  elems = utils.makeArray( elems );
  while ( elems.length ) {
    toElem.appendChild( elems.shift() );
  }
}

// -------------------------- Flickity -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Flickity intances
var instances = {};

function Flickity( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // do not initialize twice on same element
  if ( this.element.flickityGUID ) {
    var instance = instances[ this.element.flickityGUID ];
    instance.option( options );
    return instance;
  }

  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }
  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // kick things off
  this._create();
}

Flickity.defaults = {
  accessibility: true,
  // adaptiveHeight: false,
  cellAlign: 'center',
  // cellSelector: undefined,
  // contain: false,
  freeScrollFriction: 0.075, // friction when free-scrolling
  friction: 0.28, // friction when selecting
  namespaceJQueryEvents: true,
  // initialIndex: 0,
  percentPosition: true,
  resize: true,
  selectedAttraction: 0.025,
  setGallerySize: true
  // watchCSS: false,
  // wrapAround: false
};

// hash of methods triggered on _create()
Flickity.createMethods = [];

var proto = Flickity.prototype;
// inherit EventEmitter
utils.extend( proto, EvEmitter.prototype );

proto._create = function() {
  // add id for Flickity.data
  var id = this.guid = ++GUID;
  this.element.flickityGUID = id; // expando
  instances[ id ] = this; // associate via id
  // initial properties
  this.selectedIndex = 0;
  // how many frames slider has been in same position
  this.restingFrames = 0;
  // initial physics properties
  this.x = 0;
  this.velocity = 0;
  this.originSide = this.options.rightToLeft ? 'right' : 'left';
  // create viewport & slider
  this.viewport = document.createElement('div');
  this.viewport.className = 'flickity-viewport';
  this._createSlider();

  if ( this.options.resize || this.options.watchCSS ) {
    window.addEventListener( 'resize', this );
  }

  Flickity.createMethods.forEach( function( method ) {
    this[ method ]();
  }, this );

  if ( this.options.watchCSS ) {
    this.watchCSS();
  } else {
    this.activate();
  }

};

/**
 * set options
 * @param {Object} opts
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

proto.activate = function() {
  if ( this.isActive ) {
    return;
  }
  this.isActive = true;
  this.element.classList.add('flickity-enabled');
  if ( this.options.rightToLeft ) {
    this.element.classList.add('flickity-rtl');
  }

  this.getSize();
  // move initial cell elements so they can be loaded as cells
  var cellElems = this._filterFindCellElements( this.element.children );
  moveElements( cellElems, this.slider );
  this.viewport.appendChild( this.slider );
  this.element.appendChild( this.viewport );
  // get cells from children
  this.reloadCells();

  if ( this.options.accessibility ) {
    // allow element to focusable
    this.element.tabIndex = 0;
    // listen for key presses
    this.element.addEventListener( 'keydown', this );
  }

  this.emitEvent('activate');

  var index;
  var initialIndex = this.options.initialIndex;
  if ( this.isInitActivated ) {
    index = this.selectedIndex;
  } else if ( initialIndex !== undefined ) {
    index = this.cells[ initialIndex ] ? initialIndex : 0;
  } else {
    index = 0;
  }
  // select instantly
  this.select( index, false, true );
  // flag for initial activation, for using initialIndex
  this.isInitActivated = true;
};

// slider positions the cells
proto._createSlider = function() {
  // slider element does all the positioning
  var slider = document.createElement('div');
  slider.className = 'flickity-slider';
  slider.style[ this.originSide ] = 0;
  this.slider = slider;
};

proto._filterFindCellElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.cellSelector );
};

// goes through all children
proto.reloadCells = function() {
  // collection of item elements
  this.cells = this._makeCells( this.slider.children );
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
};

/**
 * turn elements into Flickity.Cells
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - collection of new Flickity Cells
 */
proto._makeCells = function( elems ) {
  var cellElems = this._filterFindCellElements( elems );

  // create new Flickity for collection
  var cells = cellElems.map( function( cellElem ) {
    return new Cell( cellElem, this );
  }, this );

  return cells;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.getLastSlide = function() {
  return this.slides[ this.slides.length - 1 ];
};

// positions all cells
proto.positionCells = function() {
  // size all cells
  this._sizeCells( this.cells );
  // position all cells
  this._positionCells( 0 );
};

/**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */
proto._positionCells = function( index ) {
  index = index || 0;
  // also measure maxCellHeight
  // start 0 if positioning all cells
  this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
  var cellX = 0;
  // get cellX
  if ( index > 0 ) {
    var startCell = this.cells[ index - 1 ];
    cellX = startCell.x + startCell.size.outerWidth;
  }
  var len = this.cells.length;
  for ( var i=index; i < len; i++ ) {
    var cell = this.cells[i];
    cell.setPosition( cellX );
    cellX += cell.size.outerWidth;
    this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
  }
  // keep track of cellX for wrap-around
  this.slideableWidth = cellX;
  // slides
  this.updateSlides();
  // contain slides target
  this._containSlides();
  // update slidesWidth
  this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
};

/**
 * cell.getSize() on multiple cells
 * @param {Array} cells
 */
proto._sizeCells = function( cells ) {
  cells.forEach( function( cell ) {
    cell.getSize();
  });
};

// --------------------------  -------------------------- //

proto.updateSlides = function() {
  this.slides = [];
  if ( !this.cells.length ) {
    return;
  }

  var slide = new Slide( this );
  this.slides.push( slide );
  var isOriginLeft = this.originSide == 'left';
  var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

  var canCellFit = this._getCanCellFit();

  this.cells.forEach( function( cell, i ) {
    // just add cell if first cell in slide
    if ( !slide.cells.length ) {
      slide.addCell( cell );
      return;
    }

    var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
      ( cell.size.outerWidth - cell.size[ nextMargin ] );

    if ( canCellFit.call( this, i, slideWidth ) ) {
      slide.addCell( cell );
    } else {
      // doesn't fit, new slide
      slide.updateTarget();

      slide = new Slide( this );
      this.slides.push( slide );
      slide.addCell( cell );
    }
  }, this );
  // last slide
  slide.updateTarget();
  // update .selectedSlide
  this.updateSelectedSlide();
};

proto._getCanCellFit = function() {
  var groupCells = this.options.groupCells;
  if ( !groupCells ) {
    return function() {
      return false;
    };
  } else if ( typeof groupCells == 'number' ) {
    // group by number. 3 -> [0,1,2], [3,4,5], ...
    var number = parseInt( groupCells, 10 );
    return function( i ) {
      return ( i % number ) !== 0;
    };
  }
  // default, group by width of slide
  // parse '75%
  var percentMatch = typeof groupCells == 'string' &&
    groupCells.match(/^(\d+)%$/);
  var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
  return function( i, slideWidth ) {
    return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
  };
};

// alias _init for jQuery plugin .flickity()
proto._init =
proto.reposition = function() {
  this.positionCells();
  this.positionSliderAtSelected();
};

proto.getSize = function() {
  this.size = getSize( this.element );
  this.setCellAlign();
  this.cursorPosition = this.size.innerWidth * this.cellAlign;
};

var cellAlignShorthands = {
  // cell align, then based on origin side
  center: {
    left: 0.5,
    right: 0.5
  },
  left: {
    left: 0,
    right: 1
  },
  right: {
    right: 0,
    left: 1
  }
};

proto.setCellAlign = function() {
  var shorthand = cellAlignShorthands[ this.options.cellAlign ];
  this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
};

proto.setGallerySize = function() {
  if ( this.options.setGallerySize ) {
    var height = this.options.adaptiveHeight && this.selectedSlide ?
      this.selectedSlide.height : this.maxCellHeight;
    this.viewport.style.height = height + 'px';
  }
};

proto._getWrapShiftCells = function() {
  // only for wrap-around
  if ( !this.options.wrapAround ) {
    return;
  }
  // unshift previous cells
  this._unshiftCells( this.beforeShiftCells );
  this._unshiftCells( this.afterShiftCells );
  // get before cells
  // initial gap
  var gapX = this.cursorPosition;
  var cellIndex = this.cells.length - 1;
  this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
  // get after cells
  // ending gap between last cell and end of gallery viewport
  gapX = this.size.innerWidth - this.cursorPosition;
  // start cloning at first cell, working forwards
  this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
};

proto._getGapCells = function( gapX, cellIndex, increment ) {
  // keep adding cells until the cover the initial gap
  var cells = [];
  while ( gapX > 0 ) {
    var cell = this.cells[ cellIndex ];
    if ( !cell ) {
      break;
    }
    cells.push( cell );
    cellIndex += increment;
    gapX -= cell.size.outerWidth;
  }
  return cells;
};

// ----- contain ----- //

// contain cell targets so no excess sliding
proto._containSlides = function() {
  if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
    return;
  }
  var isRightToLeft = this.options.rightToLeft;
  var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
  var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
  var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
  // content is less than gallery size
  var isContentSmaller = contentWidth < this.size.innerWidth;
  // bounds
  var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
  var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
  // contain each cell target
  this.slides.forEach( function( slide ) {
    if ( isContentSmaller ) {
      // all cells fit inside gallery
      slide.target = contentWidth * this.cellAlign;
    } else {
      // contain to bounds
      slide.target = Math.max( slide.target, beginBound );
      slide.target = Math.min( slide.target, endBound );
    }
  }, this );
};

// -----  ----- //

/**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery && this.$element ) {
    // default trigger with type if no event
    type += this.options.namespaceJQueryEvents ? '.flickity' : '';
    var $event = type;
    if ( event ) {
      // create jQuery event
      var jQEvent = jQuery.Event( event );
      jQEvent.type = type;
      $event = jQEvent;
    }
    this.$element.trigger( $event, args );
  }
};

// -------------------------- select -------------------------- //

/**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */
proto.select = function( index, isWrap, isInstant ) {
  if ( !this.isActive ) {
    return;
  }
  index = parseInt( index, 10 );
  this._wrapSelect( index );

  if ( this.options.wrapAround || isWrap ) {
    index = utils.modulo( index, this.slides.length );
  }
  // bail if invalid index
  if ( !this.slides[ index ] ) {
    return;
  }
  this.selectedIndex = index;
  this.updateSelectedSlide();
  if ( isInstant ) {
    this.positionSliderAtSelected();
  } else {
    this.startAnimation();
  }
  if ( this.options.adaptiveHeight ) {
    this.setGallerySize();
  }

  this.dispatchEvent('select');
  // old v1 event name, remove in v3
  this.dispatchEvent('cellSelect');
};

// wraps position for wrapAround, to move to closest slide. #113
proto._wrapSelect = function( index ) {
  var len = this.slides.length;
  var isWrapping = this.options.wrapAround && len > 1;
  if ( !isWrapping ) {
    return index;
  }
  var wrapIndex = utils.modulo( index, len );
  // go to shortest
  var delta = Math.abs( wrapIndex - this.selectedIndex );
  var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
  var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
  if ( !this.isDragSelect && backWrapDelta < delta ) {
    index += len;
  } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
    index -= len;
  }
  // wrap position so slider is within normal area
  if ( index < 0 ) {
    this.x -= this.slideableWidth;
  } else if ( index >= len ) {
    this.x += this.slideableWidth;
  }
};

proto.previous = function( isWrap, isInstant ) {
  this.select( this.selectedIndex - 1, isWrap, isInstant );
};

proto.next = function( isWrap, isInstant ) {
  this.select( this.selectedIndex + 1, isWrap, isInstant );
};

proto.updateSelectedSlide = function() {
  var slide = this.slides[ this.selectedIndex ];
  // selectedIndex could be outside of slides, if triggered before resize()
  if ( !slide ) {
    return;
  }
  // unselect previous selected slide
  this.unselectSelectedSlide();
  // update new selected slide
  this.selectedSlide = slide;
  slide.select();
  this.selectedCells = slide.cells;
  this.selectedElements = slide.getCellElements();
  // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
  // Remove in v3?
  this.selectedCell = slide.cells[0];
  this.selectedElement = this.selectedElements[0];
};

proto.unselectSelectedSlide = function() {
  if ( this.selectedSlide ) {
    this.selectedSlide.unselect();
  }
};

/**
 * select slide from number or cell element
 * @param {Element or Number} elem
 */
proto.selectCell = function( value, isWrap, isInstant ) {
  // get cell
  var cell;
  if ( typeof value == 'number' ) {
    cell = this.cells[ value ];
  } else {
    // use string as selector
    if ( typeof value == 'string' ) {
      value = this.element.querySelector( value );
    }
    // get cell from element
    cell = this.getCell( value );
  }
  // select slide that has cell
  for ( var i=0; cell && i < this.slides.length; i++ ) {
    var slide = this.slides[i];
    var index = slide.cells.indexOf( cell );
    if ( index != -1 ) {
      this.select( i, isWrap, isInstant );
      return;
    }
  }
};

// -------------------------- get cells -------------------------- //

/**
 * get Flickity.Cell, given an Element
 * @param {Element} elem
 * @returns {Flickity.Cell} item
 */
proto.getCell = function( elem ) {
  // loop through cells to get the one that matches
  for ( var i=0; i < this.cells.length; i++ ) {
    var cell = this.cells[i];
    if ( cell.element == elem ) {
      return cell;
    }
  }
};

/**
 * get collection of Flickity.Cells, given Elements
 * @param {Element, Array, NodeList} elems
 * @returns {Array} cells - Flickity.Cells
 */
proto.getCells = function( elems ) {
  elems = utils.makeArray( elems );
  var cells = [];
  elems.forEach( function( elem ) {
    var cell = this.getCell( elem );
    if ( cell ) {
      cells.push( cell );
    }
  }, this );
  return cells;
};

/**
 * get cell elements
 * @returns {Array} cellElems
 */
proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  });
};

/**
 * get parent cell from an element
 * @param {Element} elem
 * @returns {Flickit.Cell} cell
 */
proto.getParentCell = function( elem ) {
  // first check if elem is cell
  var cell = this.getCell( elem );
  if ( cell ) {
    return cell;
  }
  // try to get parent cell elem
  elem = utils.getParent( elem, '.flickity-slider > *' );
  return this.getCell( elem );
};

/**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */
proto.getAdjacentCellElements = function( adjCount, index ) {
  if ( !adjCount ) {
    return this.selectedSlide.getCellElements();
  }
  index = index === undefined ? this.selectedIndex : index;

  var len = this.slides.length;
  if ( 1 + ( adjCount * 2 ) >= len ) {
    return this.getCellElements();
  }

  var cellElems = [];
  for ( var i = index - adjCount; i <= index + adjCount ; i++ ) {
    var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
    var slide = this.slides[ slideIndex ];
    if ( slide ) {
      cellElems = cellElems.concat( slide.getCellElements() );
    }
  }
  return cellElems;
};

// -------------------------- events -------------------------- //

proto.uiChange = function() {
  this.emitEvent('uiChange');
};

proto.childUIPointerDown = function( event ) {
  this.emitEvent( 'childUIPointerDown', [ event ] );
};

// ----- resize ----- //

proto.onresize = function() {
  this.watchCSS();
  this.resize();
};

utils.debounceMethod( Flickity, 'onresize', 150 );

proto.resize = function() {
  if ( !this.isActive ) {
    return;
  }
  this.getSize();
  // wrap values
  if ( this.options.wrapAround ) {
    this.x = utils.modulo( this.x, this.slideableWidth );
  }
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
  this.emitEvent('resize');
  // update selected index for group slides, instant
  // TODO: position can be lost between groups of various numbers
  var selectedElement = this.selectedElements && this.selectedElements[0];
  this.selectCell( selectedElement, false, true );
};

// watches the :after property, activates/deactivates
proto.watchCSS = function() {
  var watchOption = this.options.watchCSS;
  if ( !watchOption ) {
    return;
  }

  var afterContent = getComputedStyle( this.element, ':after' ).content;
  // activate if :after { content: 'flickity' }
  if ( afterContent.indexOf('flickity') != -1 ) {
    this.activate();
  } else {
    this.deactivate();
  }
};

// ----- keydown ----- //

// go previous/next if left/right keys pressed
proto.onkeydown = function( event ) {
  // only work if element is in focus
  if ( !this.options.accessibility ||
    ( document.activeElement && document.activeElement != this.element ) ) {
    return;
  }

  if ( event.keyCode == 37 ) {
    // go left
    var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
    this.uiChange();
    this[ leftMethod ]();
  } else if ( event.keyCode == 39 ) {
    // go right
    var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
    this.uiChange();
    this[ rightMethod ]();
  }
};

// -------------------------- destroy -------------------------- //

// deactivate all Flickity functionality, but keep stuff available
proto.deactivate = function() {
  if ( !this.isActive ) {
    return;
  }
  this.element.classList.remove('flickity-enabled');
  this.element.classList.remove('flickity-rtl');
  // destroy cells
  this.cells.forEach( function( cell ) {
    cell.destroy();
  });
  this.unselectSelectedSlide();
  this.element.removeChild( this.viewport );
  // move child elements back into element
  moveElements( this.slider.children, this.element );
  if ( this.options.accessibility ) {
    this.element.removeAttribute('tabIndex');
    this.element.removeEventListener( 'keydown', this );
  }
  // set flags
  this.isActive = false;
  this.emitEvent('deactivate');
};

proto.destroy = function() {
  this.deactivate();
  window.removeEventListener( 'resize', this );
  this.emitEvent('destroy');
  if ( jQuery && this.$element ) {
    jQuery.removeData( this.element, 'flickity' );
  }
  delete this.element.flickityGUID;
  delete instances[ this.guid ];
};

// -------------------------- prototype -------------------------- //

utils.extend( proto, animatePrototype );

// -------------------------- extras -------------------------- //

/**
 * get Flickity instance from element
 * @param {Element} elem
 * @returns {Flickity}
 */
Flickity.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.flickityGUID;
  return id && instances[ id ];
};

utils.htmlInit( Flickity, 'flickity' );

if ( jQuery && jQuery.bridget ) {
  jQuery.bridget( 'flickity', Flickity );
}

Flickity.Cell = Cell;

return Flickity;

}));

/*!
 * Unipointer v2.1.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*global define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'unipointer/unipointer',[
      'ev-emitter/ev-emitter'
    ], function( EvEmitter ) {
      return factory( window, EvEmitter );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.Unipointer = factory(
      window,
      window.EvEmitter
    );
  }

}( window, function factory( window, EvEmitter ) {



function noop() {}

function Unipointer() {}

// inherit EvEmitter
var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );

proto.bindStartEvent = function( elem ) {
  this._bindStartEvent( elem, true );
};

proto.unbindStartEvent = function( elem ) {
  this._bindStartEvent( elem, false );
};

/**
 * works as unbinder, as you can ._bindStart( false ) to unbind
 * @param {Boolean} isBind - will unbind if falsey
 */
proto._bindStartEvent = function( elem, isBind ) {
  // munge isBind, default to true
  isBind = isBind === undefined ? true : !!isBind;
  var bindMethod = isBind ? 'addEventListener' : 'removeEventListener';

  if ( window.navigator.pointerEnabled ) {
    // W3C Pointer Events, IE11. See https://coderwall.com/p/mfreca
    elem[ bindMethod ]( 'pointerdown', this );
  } else if ( window.navigator.msPointerEnabled ) {
    // IE10 Pointer Events
    elem[ bindMethod ]( 'MSPointerDown', this );
  } else {
    // listen for both, for devices like Chrome Pixel
    elem[ bindMethod ]( 'mousedown', this );
    elem[ bindMethod ]( 'touchstart', this );
  }
};

// trigger handler methods for events
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// returns the touch that we're keeping track of
proto.getTouch = function( touches ) {
  for ( var i=0; i < touches.length; i++ ) {
    var touch = touches[i];
    if ( touch.identifier == this.pointerIdentifier ) {
      return touch;
    }
  }
};

// ----- start event ----- //

proto.onmousedown = function( event ) {
  // dismiss clicks from right or middle buttons
  var button = event.button;
  if ( button && ( button !== 0 && button !== 1 ) ) {
    return;
  }
  this._pointerDown( event, event );
};

proto.ontouchstart = function( event ) {
  this._pointerDown( event, event.changedTouches[0] );
};

proto.onMSPointerDown =
proto.onpointerdown = function( event ) {
  this._pointerDown( event, event );
};

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto._pointerDown = function( event, pointer ) {
  // dismiss other pointers
  if ( this.isPointerDown ) {
    return;
  }

  this.isPointerDown = true;
  // save pointer identifier to match up touch events
  this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;

  this.pointerDown( event, pointer );
};

proto.pointerDown = function( event, pointer ) {
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// hash of events to be bound after start event
var postStartEvents = {
  mousedown: [ 'mousemove', 'mouseup' ],
  touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
  pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
  MSPointerDown: [ 'MSPointerMove', 'MSPointerUp', 'MSPointerCancel' ]
};

proto._bindPostStartEvents = function( event ) {
  if ( !event ) {
    return;
  }
  // get proper events to match start event
  var events = postStartEvents[ event.type ];
  // bind events to node
  events.forEach( function( eventName ) {
    window.addEventListener( eventName, this );
  }, this );
  // save these arguments
  this._boundPointerEvents = events;
};

proto._unbindPostStartEvents = function() {
  // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
  if ( !this._boundPointerEvents ) {
    return;
  }
  this._boundPointerEvents.forEach( function( eventName ) {
    window.removeEventListener( eventName, this );
  }, this );

  delete this._boundPointerEvents;
};

// ----- move event ----- //

proto.onmousemove = function( event ) {
  this._pointerMove( event, event );
};

proto.onMSPointerMove =
proto.onpointermove = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerMove( event, event );
  }
};

proto.ontouchmove = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerMove( event, touch );
  }
};

/**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerMove = function( event, pointer ) {
  this.pointerMove( event, pointer );
};

// public
proto.pointerMove = function( event, pointer ) {
  this.emitEvent( 'pointerMove', [ event, pointer ] );
};

// ----- end event ----- //


proto.onmouseup = function( event ) {
  this._pointerUp( event, event );
};

proto.onMSPointerUp =
proto.onpointerup = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerUp( event, event );
  }
};

proto.ontouchend = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerUp( event, touch );
  }
};

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerUp = function( event, pointer ) {
  this._pointerDone();
  this.pointerUp( event, pointer );
};

// public
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
};

// ----- pointer done ----- //

// triggered on pointer up & pointer cancel
proto._pointerDone = function() {
  // reset properties
  this.isPointerDown = false;
  delete this.pointerIdentifier;
  // remove events
  this._unbindPostStartEvents();
  this.pointerDone();
};

proto.pointerDone = noop;

// ----- pointer cancel ----- //

proto.onMSPointerCancel =
proto.onpointercancel = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerCancel( event, event );
  }
};

proto.ontouchcancel = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerCancel( event, touch );
  }
};

/**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerCancel = function( event, pointer ) {
  this._pointerDone();
  this.pointerCancel( event, pointer );
};

// public
proto.pointerCancel = function( event, pointer ) {
  this.emitEvent( 'pointerCancel', [ event, pointer ] );
};

// -----  ----- //

// utility function for getting x/y coords from event
Unipointer.getPointerPoint = function( pointer ) {
  return {
    x: pointer.pageX,
    y: pointer.pageY
  };
};

// -----  ----- //

return Unipointer;

}));

/*!
 * Unidragger v2.1.0
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'unidragger/unidragger',[
      'unipointer/unipointer'
    ], function( Unipointer ) {
      return factory( window, Unipointer );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('unipointer')
    );
  } else {
    // browser global
    window.Unidragger = factory(
      window,
      window.Unipointer
    );
  }

}( window, function factory( window, Unipointer ) {



// -----  ----- //

function noop() {}

// -------------------------- Unidragger -------------------------- //

function Unidragger() {}

// inherit Unipointer & EvEmitter
var proto = Unidragger.prototype = Object.create( Unipointer.prototype );

// ----- bind start ----- //

proto.bindHandles = function() {
  this._bindHandles( true );
};

proto.unbindHandles = function() {
  this._bindHandles( false );
};

var navigator = window.navigator;
/**
 * works as unbinder, as you can .bindHandles( false ) to unbind
 * @param {Boolean} isBind - will unbind if falsey
 */
proto._bindHandles = function( isBind ) {
  // munge isBind, default to true
  isBind = isBind === undefined ? true : !!isBind;
  // extra bind logic
  var binderExtra;
  if ( navigator.pointerEnabled ) {
    binderExtra = function( handle ) {
      // disable scrolling on the element
      handle.style.touchAction = isBind ? 'none' : '';
    };
  } else if ( navigator.msPointerEnabled ) {
    binderExtra = function( handle ) {
      // disable scrolling on the element
      handle.style.msTouchAction = isBind ? 'none' : '';
    };
  } else {
    binderExtra = noop;
  }
  // bind each handle
  var bindMethod = isBind ? 'addEventListener' : 'removeEventListener';
  for ( var i=0; i < this.handles.length; i++ ) {
    var handle = this.handles[i];
    this._bindStartEvent( handle, isBind );
    binderExtra( handle );
    handle[ bindMethod ]( 'click', this );
  }
};

// ----- start event ----- //

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerDown = function( event, pointer ) {
  // dismiss range sliders
  if ( event.target.nodeName == 'INPUT' && event.target.type == 'range' ) {
    // reset pointerDown logic
    this.isPointerDown = false;
    delete this.pointerIdentifier;
    return;
  }

  this._dragPointerDown( event, pointer );
  // kludge to blur focused inputs in dragger
  var focused = document.activeElement;
  if ( focused && focused.blur ) {
    focused.blur();
  }
  // bind move and end events
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// base pointer down logic
proto._dragPointerDown = function( event, pointer ) {
  // track to see when dragging starts
  this.pointerDownPoint = Unipointer.getPointerPoint( pointer );

  var canPreventDefault = this.canPreventDefaultOnPointerDown( event, pointer );
  if ( canPreventDefault ) {
    event.preventDefault();
  }
};

// overwriteable method so Flickity can prevent for scrolling
proto.canPreventDefaultOnPointerDown = function( event ) {
  // prevent default, unless touchstart or <select>
  return event.target.nodeName != 'SELECT';
};

// ----- move event ----- //

/**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

// base pointer move logic
proto._dragPointerMove = function( event, pointer ) {
  var movePoint = Unipointer.getPointerPoint( pointer );
  var moveVector = {
    x: movePoint.x - this.pointerDownPoint.x,
    y: movePoint.y - this.pointerDownPoint.y
  };
  // start drag if pointer has moved far enough to start drag
  if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
    this._dragStart( event, pointer );
  }
  return moveVector;
};

// condition if pointer has moved far enough to start drag
proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
};


// ----- end event ----- //

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
  this._dragPointerUp( event, pointer );
};

proto._dragPointerUp = function( event, pointer ) {
  if ( this.isDragging ) {
    this._dragEnd( event, pointer );
  } else {
    // pointer didn't move enough for drag to start
    this._staticClick( event, pointer );
  }
};

// -------------------------- drag -------------------------- //

// dragStart
proto._dragStart = function( event, pointer ) {
  this.isDragging = true;
  this.dragStartPoint = Unipointer.getPointerPoint( pointer );
  // prevent clicks
  this.isPreventingClicks = true;

  this.dragStart( event, pointer );
};

proto.dragStart = function( event, pointer ) {
  this.emitEvent( 'dragStart', [ event, pointer ] );
};

// dragMove
proto._dragMove = function( event, pointer, moveVector ) {
  // do not drag if not dragging yet
  if ( !this.isDragging ) {
    return;
  }

  this.dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  event.preventDefault();
  this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
};

// dragEnd
proto._dragEnd = function( event, pointer ) {
  // set flags
  this.isDragging = false;
  // re-enable clicking async
  setTimeout( function() {
    delete this.isPreventingClicks;
  }.bind( this ) );

  this.dragEnd( event, pointer );
};

proto.dragEnd = function( event, pointer ) {
  this.emitEvent( 'dragEnd', [ event, pointer ] );
};

// ----- onclick ----- //

// handle all clicks and prevent clicks when dragging
proto.onclick = function( event ) {
  if ( this.isPreventingClicks ) {
    event.preventDefault();
  }
};

// ----- staticClick ----- //

// triggered after pointer down & up with no/tiny movement
proto._staticClick = function( event, pointer ) {
  // ignore emulated mouse up clicks
  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
    return;
  }

  // allow click in <input>s and <textarea>s
  var nodeName = event.target.nodeName;
  if ( nodeName == 'INPUT' || nodeName == 'TEXTAREA' ) {
    event.target.focus();
  }
  this.staticClick( event, pointer );

  // set flag for emulated clicks 300ms after touchend
  if ( event.type != 'mouseup' ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 300ms
    setTimeout( function() {
      delete this.isIgnoringMouseUp;
    }.bind( this ), 400 );
  }
};

proto.staticClick = function( event, pointer ) {
  this.emitEvent( 'staticClick', [ event, pointer ] );
};

// ----- utils ----- //

Unidragger.getPointerPoint = Unipointer.getPointerPoint;

// -----  ----- //

return Unidragger;

}));

// drag
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/drag',[
      './flickity',
      'unidragger/unidragger',
      'fizzy-ui-utils/utils'
    ], function( Flickity, Unidragger, utils ) {
      return factory( window, Flickity, Unidragger, utils );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('unidragger'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = factory(
      window,
      window.Flickity,
      window.Unidragger,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unidragger, utils ) {



// ----- defaults ----- //

utils.extend( Flickity.defaults, {
  draggable: true,
  dragThreshold: 3,
});

// ----- create ----- //

Flickity.createMethods.push('_createDrag');

// -------------------------- drag prototype -------------------------- //

var proto = Flickity.prototype;
utils.extend( proto, Unidragger.prototype );

// --------------------------  -------------------------- //

var isTouch = 'createTouch' in document;
var isTouchmoveScrollCanceled = false;

proto._createDrag = function() {
  this.on( 'activate', this.bindDrag );
  this.on( 'uiChange', this._uiChangeDrag );
  this.on( 'childUIPointerDown', this._childUIPointerDownDrag );
  this.on( 'deactivate', this.unbindDrag );
  // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
  // #457, RubaXa/Sortable#973
  if ( isTouch && !isTouchmoveScrollCanceled ) {
    window.addEventListener( 'touchmove', function() {});
    isTouchmoveScrollCanceled = true;
  }
};

proto.bindDrag = function() {
  if ( !this.options.draggable || this.isDragBound ) {
    return;
  }
  this.element.classList.add('is-draggable');
  this.handles = [ this.viewport ];
  this.bindHandles();
  this.isDragBound = true;
};

proto.unbindDrag = function() {
  if ( !this.isDragBound ) {
    return;
  }
  this.element.classList.remove('is-draggable');
  this.unbindHandles();
  delete this.isDragBound;
};

proto._uiChangeDrag = function() {
  delete this.isFreeScrolling;
};

proto._childUIPointerDownDrag = function( event ) {
  event.preventDefault();
  this.pointerDownFocus( event );
};

// -------------------------- pointer events -------------------------- //

// nodes that have text fields
var cursorNodes = {
  TEXTAREA: true,
  INPUT: true,
  OPTION: true,
};

// input types that do not have text fields
var clickTypes = {
  radio: true,
  checkbox: true,
  button: true,
  submit: true,
  image: true,
  file: true,
};

proto.pointerDown = function( event, pointer ) {
  // dismiss inputs with text fields. #403, #404
  var isCursorInput = cursorNodes[ event.target.nodeName ] &&
    !clickTypes[ event.target.type ];
  if ( isCursorInput ) {
    // reset pointerDown logic
    this.isPointerDown = false;
    delete this.pointerIdentifier;
    return;
  }

  this._dragPointerDown( event, pointer );

  // kludge to blur focused inputs in dragger
  var focused = document.activeElement;
  if ( focused && focused.blur && focused != this.element &&
    // do not blur body for IE9 & 10, #117
    focused != document.body ) {
    focused.blur();
  }
  this.pointerDownFocus( event );
  // stop if it was moving
  this.dragX = this.x;
  this.viewport.classList.add('is-pointer-down');
  // bind move and end events
  this._bindPostStartEvents( event );
  // track scrolling
  this.pointerDownScroll = getScrollPosition();
  window.addEventListener( 'scroll', this );

  this.dispatchEvent( 'pointerDown', event, [ pointer ] );
};

var touchStartEvents = {
  touchstart: true,
  MSPointerDown: true
};

var focusNodes = {
  INPUT: true,
  SELECT: true
};

proto.pointerDownFocus = function( event ) {
  // focus element, if not touch, and its not an input or select
  if ( !this.options.accessibility || touchStartEvents[ event.type ] ||
      focusNodes[ event.target.nodeName ] ) {
    return;
  }
  var prevScrollY = window.pageYOffset;
  this.element.focus();
  // hack to fix scroll jump after focus, #76
  if ( window.pageYOffset != prevScrollY ) {
    window.scrollTo( window.pageXOffset, prevScrollY );
  }
};

proto.canPreventDefaultOnPointerDown = function( event ) {
  // prevent default, unless touchstart or <select>
  var isTouchstart = event.type == 'touchstart';
  var targetNodeName = event.target.nodeName;
  return !isTouchstart && targetNodeName != 'SELECT';
};

// ----- move ----- //

proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > this.options.dragThreshold;
};

// ----- up ----- //

proto.pointerUp = function( event, pointer ) {
  delete this.isTouchScrolling;
  this.viewport.classList.remove('is-pointer-down');
  this.dispatchEvent( 'pointerUp', event, [ pointer ] );
  this._dragPointerUp( event, pointer );
};

proto.pointerDone = function() {
  window.removeEventListener( 'scroll', this );
  delete this.pointerDownScroll;
};

// -------------------------- dragging -------------------------- //

proto.dragStart = function( event, pointer ) {
  this.dragStartPosition = this.x;
  this.startAnimation();
  window.removeEventListener( 'scroll', this );
  this.dispatchEvent( 'dragStart', event, [ pointer ] );
};

proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  event.preventDefault();

  this.previousDragX = this.dragX;
  // reverse if right-to-left
  var direction = this.options.rightToLeft ? -1 : 1;
  var dragX = this.dragStartPosition + moveVector.x * direction;

  if ( !this.options.wrapAround && this.slides.length ) {
    // slow drag
    var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
    dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
    var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
    dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
  }

  this.dragX = dragX;

  this.dragMoveTime = new Date();
  this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
};

proto.dragEnd = function( event, pointer ) {
  if ( this.options.freeScroll ) {
    this.isFreeScrolling = true;
  }
  // set selectedIndex based on where flick will end up
  var index = this.dragEndRestingSelect();

  if ( this.options.freeScroll && !this.options.wrapAround ) {
    // if free-scroll & not wrap around
    // do not free-scroll if going outside of bounding slides
    // so bounding slides can attract slider, and keep it in bounds
    var restingX = this.getRestingPosition();
    this.isFreeScrolling = -restingX > this.slides[0].target &&
      -restingX < this.getLastSlide().target;
  } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
    // boost selection if selected index has not changed
    index += this.dragEndBoostSelect();
  }
  delete this.previousDragX;
  // apply selection
  // TODO refactor this, selecting here feels weird
  // HACK, set flag so dragging stays in correct direction
  this.isDragSelect = this.options.wrapAround;
  this.select( index );
  delete this.isDragSelect;
  this.dispatchEvent( 'dragEnd', event, [ pointer ] );
};

proto.dragEndRestingSelect = function() {
  var restingX = this.getRestingPosition();
  // how far away from selected slide
  var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
  // get closet resting going up and going down
  var positiveResting = this._getClosestResting( restingX, distance, 1 );
  var negativeResting = this._getClosestResting( restingX, distance, -1 );
  // use closer resting for wrap-around
  var index = positiveResting.distance < negativeResting.distance ?
    positiveResting.index : negativeResting.index;
  return index;
};

/**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */
proto._getClosestResting = function( restingX, distance, increment ) {
  var index = this.selectedIndex;
  var minDistance = Infinity;
  var condition = this.options.contain && !this.options.wrapAround ?
    // if contain, keep going if distance is equal to minDistance
    function( d, md ) { return d <= md; } : function( d, md ) { return d < md; };
  while ( condition( distance, minDistance ) ) {
    // measure distance to next cell
    index += increment;
    minDistance = distance;
    distance = this.getSlideDistance( -restingX, index );
    if ( distance === null ) {
      break;
    }
    distance = Math.abs( distance );
  }
  return {
    distance: minDistance,
    // selected was previous index
    index: index - increment
  };
};

/**
 * measure distance between x and a slide target
 * @param {Number} x
 * @param {Integer} index - slide index
 */
proto.getSlideDistance = function( x, index ) {
  var len = this.slides.length;
  // wrap around if at least 2 slides
  var isWrapAround = this.options.wrapAround && len > 1;
  var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
  var slide = this.slides[ slideIndex ];
  if ( !slide ) {
    return null;
  }
  // add distance for wrap-around slides
  var wrap = isWrapAround ? this.slideableWidth * Math.floor( index / len ) : 0;
  return x - ( slide.target + wrap );
};

proto.dragEndBoostSelect = function() {
  // do not boost if no previousDragX or dragMoveTime
  if ( this.previousDragX === undefined || !this.dragMoveTime ||
    // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100 ) {
    return 0;
  }

  var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
  var delta = this.previousDragX - this.dragX;
  if ( distance > 0 && delta > 0 ) {
    // boost to next if moving towards the right, and positive velocity
    return 1;
  } else if ( distance < 0 && delta < 0 ) {
    // boost to previous if moving towards the left, and negative velocity
    return -1;
  }
  return 0;
};

// ----- staticClick ----- //

proto.staticClick = function( event, pointer ) {
  // get clickedCell, if cell was clicked
  var clickedCell = this.getParentCell( event.target );
  var cellElem = clickedCell && clickedCell.element;
  var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
  this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
};

// ----- scroll ----- //

proto.onscroll = function() {
  var scroll = getScrollPosition();
  var scrollMoveX = this.pointerDownScroll.x - scroll.x;
  var scrollMoveY = this.pointerDownScroll.y - scroll.y;
  // cancel click/tap if scroll is too much
  if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
    this._pointerDone();
  }
};

// ----- utils ----- //

function getScrollPosition() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}

// -----  ----- //

return Flickity;

}));

/*!
 * Tap listener v2.0.0
 * listens to taps
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false*/ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'tap-listener/tap-listener',[
      'unipointer/unipointer'
    ], function( Unipointer ) {
      return factory( window, Unipointer );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('unipointer')
    );
  } else {
    // browser global
    window.TapListener = factory(
      window,
      window.Unipointer
    );
  }

}( window, function factory( window, Unipointer ) {



// --------------------------  TapListener -------------------------- //

function TapListener( elem ) {
  this.bindTap( elem );
}

// inherit Unipointer & EventEmitter
var proto = TapListener.prototype = Object.create( Unipointer.prototype );

/**
 * bind tap event to element
 * @param {Element} elem
 */
proto.bindTap = function( elem ) {
  if ( !elem ) {
    return;
  }
  this.unbindTap();
  this.tapElement = elem;
  this._bindStartEvent( elem, true );
};

proto.unbindTap = function() {
  if ( !this.tapElement ) {
    return;
  }
  this._bindStartEvent( this.tapElement, true );
  delete this.tapElement;
};

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerUp = function( event, pointer ) {
  // ignore emulated mouse up clicks
  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
    return;
  }

  var pointerPoint = Unipointer.getPointerPoint( pointer );
  var boundingRect = this.tapElement.getBoundingClientRect();
  var scrollX = window.pageXOffset;
  var scrollY = window.pageYOffset;
  // calculate if pointer is inside tapElement
  var isInside = pointerPoint.x >= boundingRect.left + scrollX &&
    pointerPoint.x <= boundingRect.right + scrollX &&
    pointerPoint.y >= boundingRect.top + scrollY &&
    pointerPoint.y <= boundingRect.bottom + scrollY;
  // trigger callback if pointer is inside element
  if ( isInside ) {
    this.emitEvent( 'tap', [ event, pointer ] );
  }

  // set flag for emulated clicks 300ms after touchend
  if ( event.type != 'mouseup' ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 300ms
    var _this = this;
    setTimeout( function() {
      delete _this.isIgnoringMouseUp;
    }, 400 );
  }
};

proto.destroy = function() {
  this.pointerDone();
  this.unbindTap();
};

// -----  ----- //

return TapListener;

}));

// prev/next buttons
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/prev-next-button',[
      './flickity',
      'tap-listener/tap-listener',
      'fizzy-ui-utils/utils'
    ], function( Flickity, TapListener, utils ) {
      return factory( window, Flickity, TapListener, utils );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('tap-listener'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
      window,
      window.Flickity,
      window.TapListener,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, TapListener, utils ) {
'use strict';

var svgURI = 'http://www.w3.org/2000/svg';

// -------------------------- PrevNextButton -------------------------- //

function PrevNextButton( direction, parent ) {
  this.direction = direction;
  this.parent = parent;
  this._create();
}

PrevNextButton.prototype = new TapListener();

PrevNextButton.prototype._create = function() {
  // properties
  this.isEnabled = true;
  this.isPrevious = this.direction == -1;
  var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
  this.isLeft = this.direction == leftDirection;

  var element = this.element = document.createElement('button');
  element.className = 'flickity-prev-next-button';
  element.className += this.isPrevious ? ' previous' : ' next';
  // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
  element.setAttribute( 'type', 'button' );
  // init as disabled
  this.disable();

  element.setAttribute( 'aria-label', this.isPrevious ? 'previous' : 'next' );

  // create arrow
  var svg = this.createSVG();
  element.appendChild( svg );
  // events
  this.on( 'tap', this.onTap );
  this.parent.on( 'select', this.update.bind( this ) );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PrevNextButton.prototype.activate = function() {
  this.bindTap( this.element );
  // click events from keyboard
  this.element.addEventListener( 'click', this );
  // add to DOM
  this.parent.element.appendChild( this.element );
};

PrevNextButton.prototype.deactivate = function() {
  // remove from DOM
  this.parent.element.removeChild( this.element );
  // do regular TapListener destroy
  TapListener.prototype.destroy.call( this );
  // click events from keyboard
  this.element.removeEventListener( 'click', this );
};

PrevNextButton.prototype.createSVG = function() {
  var svg = document.createElementNS( svgURI, 'svg');
  svg.setAttribute( 'viewBox', '0 0 100 100' );
  var path = document.createElementNS( svgURI, 'path');
  var pathMovements = getArrowMovements( this.parent.options.arrowShape );
  path.setAttribute( 'd', pathMovements );
  path.setAttribute( 'class', 'arrow' );
  // rotate arrow
  if ( !this.isLeft ) {
    path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
  }
  svg.appendChild( path );
  return svg;
};

// get SVG path movmement
function getArrowMovements( shape ) {
  // use shape as movement if string
  if ( typeof shape == 'string' ) {
    return shape;
  }
  // create movement string
  return 'M ' + shape.x0 + ',50' +
    ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
    ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
    ' L ' + shape.x3 + ',50 ' +
    ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
    ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
    ' Z';
}

PrevNextButton.prototype.onTap = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.parent.uiChange();
  var method = this.isPrevious ? 'previous' : 'next';
  this.parent[ method ]();
};

PrevNextButton.prototype.handleEvent = utils.handleEvent;

PrevNextButton.prototype.onclick = function() {
  // only allow clicks from keyboard
  var focused = document.activeElement;
  if ( focused && focused == this.element ) {
    this.onTap();
  }
};

// -----  ----- //

PrevNextButton.prototype.enable = function() {
  if ( this.isEnabled ) {
    return;
  }
  this.element.disabled = false;
  this.isEnabled = true;
};

PrevNextButton.prototype.disable = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.element.disabled = true;
  this.isEnabled = false;
};

PrevNextButton.prototype.update = function() {
  // index of first or last slide, if previous or next
  var slides = this.parent.slides;
  // enable is wrapAround and at least 2 slides
  if ( this.parent.options.wrapAround && slides.length > 1 ) {
    this.enable();
    return;
  }
  var lastIndex = slides.length ? slides.length - 1 : 0;
  var boundIndex = this.isPrevious ? 0 : lastIndex;
  var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
  this[ method ]();
};

PrevNextButton.prototype.destroy = function() {
  this.deactivate();
};

// -------------------------- Flickity prototype -------------------------- //

utils.extend( Flickity.defaults, {
  prevNextButtons: true,
  arrowShape: {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30
  }
});

Flickity.createMethods.push('_createPrevNextButtons');
var proto = Flickity.prototype;

proto._createPrevNextButtons = function() {
  if ( !this.options.prevNextButtons ) {
    return;
  }

  this.prevButton = new PrevNextButton( -1, this );
  this.nextButton = new PrevNextButton( 1, this );

  this.on( 'activate', this.activatePrevNextButtons );
};

proto.activatePrevNextButtons = function() {
  this.prevButton.activate();
  this.nextButton.activate();
  this.on( 'deactivate', this.deactivatePrevNextButtons );
};

proto.deactivatePrevNextButtons = function() {
  this.prevButton.deactivate();
  this.nextButton.deactivate();
  this.off( 'deactivate', this.deactivatePrevNextButtons );
};

// --------------------------  -------------------------- //

Flickity.PrevNextButton = PrevNextButton;

return Flickity;

}));

// page dots
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/page-dots',[
      './flickity',
      'tap-listener/tap-listener',
      'fizzy-ui-utils/utils'
    ], function( Flickity, TapListener, utils ) {
      return factory( window, Flickity, TapListener, utils );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('tap-listener'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
      window,
      window.Flickity,
      window.TapListener,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, TapListener, utils ) {

// -------------------------- PageDots -------------------------- //



function PageDots( parent ) {
  this.parent = parent;
  this._create();
}

PageDots.prototype = new TapListener();

PageDots.prototype._create = function() {
  // create holder element
  this.holder = document.createElement('ol');
  this.holder.className = 'flickity-page-dots';
  // create dots, array of elements
  this.dots = [];
  // events
  this.on( 'tap', this.onTap );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PageDots.prototype.activate = function() {
  this.setDots();
  this.bindTap( this.holder );
  // add to DOM
  this.parent.element.appendChild( this.holder );
};

PageDots.prototype.deactivate = function() {
  // remove from DOM
  this.parent.element.removeChild( this.holder );
  TapListener.prototype.destroy.call( this );
};

PageDots.prototype.setDots = function() {
  // get difference between number of slides and number of dots
  var delta = this.parent.slides.length - this.dots.length;
  if ( delta > 0 ) {
    this.addDots( delta );
  } else if ( delta < 0 ) {
    this.removeDots( -delta );
  }
};

PageDots.prototype.addDots = function( count ) {
  var fragment = document.createDocumentFragment();
  var newDots = [];
  while ( count ) {
    var dot = document.createElement('li');
    dot.className = 'dot';
    fragment.appendChild( dot );
    newDots.push( dot );
    count--;
  }
  this.holder.appendChild( fragment );
  this.dots = this.dots.concat( newDots );
};

PageDots.prototype.removeDots = function( count ) {
  // remove from this.dots collection
  var removeDots = this.dots.splice( this.dots.length - count, count );
  // remove from DOM
  removeDots.forEach( function( dot ) {
    this.holder.removeChild( dot );
  }, this );
};

PageDots.prototype.updateSelected = function() {
  // remove selected class on previous
  if ( this.selectedDot ) {
    this.selectedDot.className = 'dot';
  }
  // don't proceed if no dots
  if ( !this.dots.length ) {
    return;
  }
  this.selectedDot = this.dots[ this.parent.selectedIndex ];
  this.selectedDot.className = 'dot is-selected';
};

PageDots.prototype.onTap = function( event ) {
  var target = event.target;
  // only care about dot clicks
  if ( target.nodeName != 'LI' ) {
    return;
  }

  this.parent.uiChange();
  var index = this.dots.indexOf( target );
  this.parent.select( index );
};

PageDots.prototype.destroy = function() {
  this.deactivate();
};

Flickity.PageDots = PageDots;

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pageDots: true
});

Flickity.createMethods.push('_createPageDots');

var proto = Flickity.prototype;

proto._createPageDots = function() {
  if ( !this.options.pageDots ) {
    return;
  }
  this.pageDots = new PageDots( this );
  // events
  this.on( 'activate', this.activatePageDots );
  this.on( 'select', this.updateSelectedPageDots );
  this.on( 'cellChange', this.updatePageDots );
  this.on( 'resize', this.updatePageDots );
  this.on( 'deactivate', this.deactivatePageDots );
};

proto.activatePageDots = function() {
  this.pageDots.activate();
};

proto.updateSelectedPageDots = function() {
  this.pageDots.updateSelected();
};

proto.updatePageDots = function() {
  this.pageDots.setDots();
};

proto.deactivatePageDots = function() {
  this.pageDots.deactivate();
};

// -----  ----- //

Flickity.PageDots = PageDots;

return Flickity;

}));

// player & autoPlay
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/player',[
      'ev-emitter/ev-emitter',
      'fizzy-ui-utils/utils',
      './flickity'
    ], function( EvEmitter, utils, Flickity ) {
      return factory( EvEmitter, utils, Flickity );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('ev-emitter'),
      require('fizzy-ui-utils'),
      require('./flickity')
    );
  } else {
    // browser global
    factory(
      window.EvEmitter,
      window.fizzyUIUtils,
      window.Flickity
    );
  }

}( window, function factory( EvEmitter, utils, Flickity ) {



// -------------------------- Page Visibility -------------------------- //
// https://developer.mozilla.org/en-US/docs/Web/Guide/User_experience/Using_the_Page_Visibility_API

var hiddenProperty, visibilityEvent;
if ( 'hidden' in document ) {
  hiddenProperty = 'hidden';
  visibilityEvent = 'visibilitychange';
} else if ( 'webkitHidden' in document ) {
  hiddenProperty = 'webkitHidden';
  visibilityEvent = 'webkitvisibilitychange';
}

// -------------------------- Player -------------------------- //

function Player( parent ) {
  this.parent = parent;
  this.state = 'stopped';
  // visibility change event handler
  if ( visibilityEvent ) {
    this.onVisibilityChange = function() {
      this.visibilityChange();
    }.bind( this );
    this.onVisibilityPlay = function() {
      this.visibilityPlay();
    }.bind( this );
  }
}

Player.prototype = Object.create( EvEmitter.prototype );

// start play
Player.prototype.play = function() {
  if ( this.state == 'playing' ) {
    return;
  }
  // do not play if page is hidden, start playing when page is visible
  var isPageHidden = document[ hiddenProperty ];
  if ( visibilityEvent && isPageHidden ) {
    document.addEventListener( visibilityEvent, this.onVisibilityPlay );
    return;
  }

  this.state = 'playing';
  // listen to visibility change
  if ( visibilityEvent ) {
    document.addEventListener( visibilityEvent, this.onVisibilityChange );
  }
  // start ticking
  this.tick();
};

Player.prototype.tick = function() {
  // do not tick if not playing
  if ( this.state != 'playing' ) {
    return;
  }

  var time = this.parent.options.autoPlay;
  // default to 3 seconds
  time = typeof time == 'number' ? time : 3000;
  var _this = this;
  // HACK: reset ticks if stopped and started within interval
  this.clear();
  this.timeout = setTimeout( function() {
    _this.parent.next( true );
    _this.tick();
  }, time );
};

Player.prototype.stop = function() {
  this.state = 'stopped';
  this.clear();
  // remove visibility change event
  if ( visibilityEvent ) {
    document.removeEventListener( visibilityEvent, this.onVisibilityChange );
  }
};

Player.prototype.clear = function() {
  clearTimeout( this.timeout );
};

Player.prototype.pause = function() {
  if ( this.state == 'playing' ) {
    this.state = 'paused';
    this.clear();
  }
};

Player.prototype.unpause = function() {
  // re-start play if paused
  if ( this.state == 'paused' ) {
    this.play();
  }
};

// pause if page visibility is hidden, unpause if visible
Player.prototype.visibilityChange = function() {
  var isPageHidden = document[ hiddenProperty ];
  this[ isPageHidden ? 'pause' : 'unpause' ]();
};

Player.prototype.visibilityPlay = function() {
  this.play();
  document.removeEventListener( visibilityEvent, this.onVisibilityPlay );
};

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pauseAutoPlayOnHover: true
});

Flickity.createMethods.push('_createPlayer');
var proto = Flickity.prototype;

proto._createPlayer = function() {
  this.player = new Player( this );

  this.on( 'activate', this.activatePlayer );
  this.on( 'uiChange', this.stopPlayer );
  this.on( 'pointerDown', this.stopPlayer );
  this.on( 'deactivate', this.deactivatePlayer );
};

proto.activatePlayer = function() {
  if ( !this.options.autoPlay ) {
    return;
  }
  this.player.play();
  this.element.addEventListener( 'mouseenter', this );
};

// Player API, don't hate the ... thanks I know where the door is

proto.playPlayer = function() {
  this.player.play();
};

proto.stopPlayer = function() {
  this.player.stop();
};

proto.pausePlayer = function() {
  this.player.pause();
};

proto.unpausePlayer = function() {
  this.player.unpause();
};

proto.deactivatePlayer = function() {
  this.player.stop();
  this.element.removeEventListener( 'mouseenter', this );
};

// ----- mouseenter/leave ----- //

// pause auto-play on hover
proto.onmouseenter = function() {
  if ( !this.options.pauseAutoPlayOnHover ) {
    return;
  }
  this.player.pause();
  this.element.addEventListener( 'mouseleave', this );
};

// resume auto-play on hover off
proto.onmouseleave = function() {
  this.player.unpause();
  this.element.removeEventListener( 'mouseleave', this );
};

// -----  ----- //

Flickity.Player = Player;

return Flickity;

}));

// add, remove cell
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/add-remove-cell',[
      './flickity',
      'fizzy-ui-utils/utils'
    ], function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
      window,
      window.Flickity,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {



// append cells to a document fragment
function getCellsFragment( cells ) {
  var fragment = document.createDocumentFragment();
  cells.forEach( function( cell ) {
    fragment.appendChild( cell.element );
  });
  return fragment;
}

// -------------------------- add/remove cell prototype -------------------------- //

var proto = Flickity.prototype;

/**
 * Insert, prepend, or append cells
 * @param {Element, Array, NodeList} elems
 * @param {Integer} index
 */
proto.insert = function( elems, index ) {
  var cells = this._makeCells( elems );
  if ( !cells || !cells.length ) {
    return;
  }
  var len = this.cells.length;
  // default to append
  index = index === undefined ? len : index;
  // add cells with document fragment
  var fragment = getCellsFragment( cells );
  // append to slider
  var isAppend = index == len;
  if ( isAppend ) {
    this.slider.appendChild( fragment );
  } else {
    var insertCellElement = this.cells[ index ].element;
    this.slider.insertBefore( fragment, insertCellElement );
  }
  // add to this.cells
  if ( index === 0 ) {
    // prepend, add to start
    this.cells = cells.concat( this.cells );
  } else if ( isAppend ) {
    // append, add to end
    this.cells = this.cells.concat( cells );
  } else {
    // insert in this.cells
    var endCells = this.cells.splice( index, len - index );
    this.cells = this.cells.concat( cells ).concat( endCells );
  }

  this._sizeCells( cells );

  var selectedIndexDelta = index > this.selectedIndex ? 0 : cells.length;
  this._cellAddedRemoved( index, selectedIndexDelta );
};

proto.append = function( elems ) {
  this.insert( elems, this.cells.length );
};

proto.prepend = function( elems ) {
  this.insert( elems, 0 );
};

/**
 * Remove cells
 * @param {Element, Array, NodeList} elems
 */
proto.remove = function( elems ) {
  var cells = this.getCells( elems );
  var selectedIndexDelta = 0;
  var len = cells.length;
  var i, cell;
  // calculate selectedIndexDelta, easier if done in seperate loop
  for ( i=0; i < len; i++ ) {
    cell = cells[i];
    var wasBefore = this.cells.indexOf( cell ) < this.selectedIndex;
    selectedIndexDelta -= wasBefore ? 1 : 0;
  }

  for ( i=0; i < len; i++ ) {
    cell = cells[i];
    cell.remove();
    // remove item from collection
    utils.removeFrom( this.cells, cell );
  }

  if ( cells.length ) {
    // update stuff
    this._cellAddedRemoved( 0, selectedIndexDelta );
  }
};

// updates when cells are added or removed
proto._cellAddedRemoved = function( changedCellIndex, selectedIndexDelta ) {
  // TODO this math isn't perfect with grouped slides
  selectedIndexDelta = selectedIndexDelta || 0;
  this.selectedIndex += selectedIndexDelta;
  this.selectedIndex = Math.max( 0, Math.min( this.slides.length - 1, this.selectedIndex ) );

  this.cellChange( changedCellIndex, true );
  // backwards compatibility
  this.emitEvent( 'cellAddedRemoved', [ changedCellIndex, selectedIndexDelta ] );
};

/**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */
proto.cellSizeChange = function( elem ) {
  var cell = this.getCell( elem );
  if ( !cell ) {
    return;
  }
  cell.getSize();

  var index = this.cells.indexOf( cell );
  this.cellChange( index );
};

/**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 */
proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
  var prevSlideableWidth = this.slideableWidth;
  this._positionCells( changedCellIndex );
  this._getWrapShiftCells();
  this.setGallerySize();
  this.emitEvent( 'cellChange', [ changedCellIndex ] );
  // position slider
  if ( this.options.freeScroll ) {
    // shift x by change in slideableWidth
    // TODO fix position shifts when prepending w/ freeScroll
    var deltaX = prevSlideableWidth - this.slideableWidth;
    this.x += deltaX * this.cellAlign;
    this.positionSlider();
  } else {
    // do not position slider after lazy load
    if ( isPositioningSlider ) {
      this.positionSliderAtSelected();
    }
    this.select( this.selectedIndex );
  }
};

// -----  ----- //

return Flickity;

}));

// lazyload
( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/lazyload',[
      './flickity',
      'fizzy-ui-utils/utils'
    ], function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('./flickity'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
      window,
      window.Flickity,
      window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {
'use strict';

Flickity.createMethods.push('_createLazyload');
var proto = Flickity.prototype;

proto._createLazyload = function() {
  this.on( 'select', this.lazyLoad );
};

proto.lazyLoad = function() {
  var lazyLoad = this.options.lazyLoad;
  if ( !lazyLoad ) {
    return;
  }
  // get adjacent cells, use lazyLoad option for adjacent count
  var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
  var cellElems = this.getAdjacentCellElements( adjCount );
  // get lazy images in those cells
  var lazyImages = [];
  cellElems.forEach( function( cellElem ) {
    var lazyCellImages = getCellLazyImages( cellElem );
    lazyImages = lazyImages.concat( lazyCellImages );
  });
  // load lazy images
  lazyImages.forEach( function( img ) {
    new LazyLoader( img, this );
  }, this );
};

function getCellLazyImages( cellElem ) {
  // check if cell element is lazy image
  if ( cellElem.nodeName == 'IMG' &&
    cellElem.getAttribute('data-flickity-lazyload') ) {
    return [ cellElem ];
  }
  // select lazy images in cell
  var imgs = cellElem.querySelectorAll('img[data-flickity-lazyload]');
  return utils.makeArray( imgs );
}

// -------------------------- LazyLoader -------------------------- //

/**
 * class to handle loading images
 */
function LazyLoader( img, flickity ) {
  this.img = img;
  this.flickity = flickity;
  this.load();
}

LazyLoader.prototype.handleEvent = utils.handleEvent;

LazyLoader.prototype.load = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  // load image
  this.img.src = this.img.getAttribute('data-flickity-lazyload');
  // remove attr
  this.img.removeAttribute('data-flickity-lazyload');
};

LazyLoader.prototype.onload = function( event ) {
  this.complete( event, 'flickity-lazyloaded' );
};

LazyLoader.prototype.onerror = function( event ) {
  this.complete( event, 'flickity-lazyerror' );
};

LazyLoader.prototype.complete = function( event, className ) {
  // unbind events
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );

  var cell = this.flickity.getParentCell( this.img );
  var cellElem = cell && cell.element;
  this.flickity.cellSizeChange( cellElem );

  this.img.classList.add( className );
  this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
};

// -----  ----- //

Flickity.LazyLoader = LazyLoader;

return Flickity;

}));

/*!
 * Flickity v2.0.5
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * http://flickity.metafizzy.co
 * Copyright 2016 Metafizzy
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/index',[
      './flickity',
      './drag',
      './prev-next-button',
      './page-dots',
      './player',
      './add-remove-cell',
      './lazyload'
    ], factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('./flickity'),
      require('./drag'),
      require('./prev-next-button'),
      require('./page-dots'),
      require('./player'),
      require('./add-remove-cell'),
      require('./lazyload')
    );
  }

})( window, function factory( Flickity ) {
  /*jshint strict: false*/
  return Flickity;
});

/*!
 * Flickity asNavFor v2.0.1
 * enable asNavFor for Flickity
 */

/*jshint browser: true, undef: true, unused: true, strict: true*/

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity-as-nav-for/as-nav-for',[
      'flickity/js/index',
      'fizzy-ui-utils/utils'
    ], factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('flickity'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = factory(
      window.Flickity,
      window.fizzyUIUtils
    );
  }

}( window, function factory( Flickity, utils ) {



// -------------------------- asNavFor prototype -------------------------- //

// Flickity.defaults.asNavFor = null;

Flickity.createMethods.push('_createAsNavFor');

var proto = Flickity.prototype;

proto._createAsNavFor = function() {
  this.on( 'activate', this.activateAsNavFor );
  this.on( 'deactivate', this.deactivateAsNavFor );
  this.on( 'destroy', this.destroyAsNavFor );

  var asNavForOption = this.options.asNavFor;
  if ( !asNavForOption ) {
    return;
  }
  // HACK do async, give time for other flickity to be initalized
  var _this = this;
  setTimeout( function initNavCompanion() {
    _this.setNavCompanion( asNavForOption );
  });
};

proto.setNavCompanion = function( elem ) {
  elem = utils.getQueryElement( elem );
  var companion = Flickity.data( elem );
  // stop if no companion or companion is self
  if ( !companion || companion == this ) {
    return;
  }

  this.navCompanion = companion;
  // companion select
  var _this = this;
  this.onNavCompanionSelect = function() {
    _this.navCompanionSelect();
  };
  companion.on( 'select', this.onNavCompanionSelect );
  // click
  this.on( 'staticClick', this.onNavStaticClick );

  this.navCompanionSelect( true );
};

proto.navCompanionSelect = function( isInstant ) {
  if ( !this.navCompanion ) {
    return;
  }
  // select slide that matches first cell of slide
  var selectedCell = this.navCompanion.selectedCells[0];
  var firstIndex = this.navCompanion.cells.indexOf( selectedCell );
  var lastIndex = firstIndex + this.navCompanion.selectedCells.length - 1;
  var selectIndex = Math.floor( lerp( firstIndex, lastIndex,
    this.navCompanion.cellAlign ) );
  this.selectCell( selectIndex, false, isInstant );
  // set nav selected class
  this.removeNavSelectedElements();
  // stop if companion has more cells than this one
  if ( selectIndex >= this.cells.length ) {
    return;
  }

  var selectedCells = this.cells.slice( firstIndex, lastIndex + 1 );
  this.navSelectedElements = selectedCells.map( function( cell ) {
    return cell.element;
  });
  this.changeNavSelectedClass('add');
};

function lerp( a, b, t ) {
  return ( b - a ) * t + a;
}

proto.changeNavSelectedClass = function( method ) {
  this.navSelectedElements.forEach( function( navElem ) {
    navElem.classList[ method ]('is-nav-selected');
  });
};

proto.activateAsNavFor = function() {
  this.navCompanionSelect( true );
};

proto.removeNavSelectedElements = function() {
  if ( !this.navSelectedElements ) {
    return;
  }
  this.changeNavSelectedClass('remove');
  delete this.navSelectedElements;
};

proto.onNavStaticClick = function( event, pointer, cellElement, cellIndex ) {
  if ( typeof cellIndex == 'number' ) {
    this.navCompanion.selectCell( cellIndex );
  }
};

proto.deactivateAsNavFor = function() {
  this.removeNavSelectedElements();
};

proto.destroyAsNavFor = function() {
  if ( !this.navCompanion ) {
    return;
  }
  this.navCompanion.off( 'select', this.onNavCompanionSelect );
  this.off( 'staticClick', this.onNavStaticClick );
  delete this.navCompanion;
};

// -----  ----- //

return Flickity;

}));

/*!
 * imagesLoaded v4.1.1
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'imagesloaded/imagesloaded',[
      'ev-emitter/ev-emitter'
    ], function( EvEmitter ) {
      return factory( window, EvEmitter );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EvEmitter
    );
  }

})( window,

// --------------------------  factory -------------------------- //

function factory( window, EvEmitter ) {



var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

// turn element or nodeList into an array
function makeArray( obj ) {
  var ary = [];
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
}

// -------------------------- imagesLoaded -------------------------- //

/**
 * @param {Array, Element, NodeList, String} elem
 * @param {Object or Function} options - if function, use as callback
 * @param {Function} onAlways - callback function
 */
function ImagesLoaded( elem, options, onAlways ) {
  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
  if ( !( this instanceof ImagesLoaded ) ) {
    return new ImagesLoaded( elem, options, onAlways );
  }
  // use elem as selector string
  if ( typeof elem == 'string' ) {
    elem = document.querySelectorAll( elem );
  }

  this.elements = makeArray( elem );
  this.options = extend( {}, this.options );

  if ( typeof options == 'function' ) {
    onAlways = options;
  } else {
    extend( this.options, options );
  }

  if ( onAlways ) {
    this.on( 'always', onAlways );
  }

  this.getImages();

  if ( $ ) {
    // add jQuery Deferred object
    this.jqDeferred = new $.Deferred();
  }

  // HACK check async to allow time to bind listeners
  setTimeout( function() {
    this.check();
  }.bind( this ));
}

ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

ImagesLoaded.prototype.options = {};

ImagesLoaded.prototype.getImages = function() {
  this.images = [];

  // filter & find items if we have an item selector
  this.elements.forEach( this.addElementImages, this );
};

/**
 * @param {Node} element
 */
ImagesLoaded.prototype.addElementImages = function( elem ) {
  // filter siblings
  if ( elem.nodeName == 'IMG' ) {
    this.addImage( elem );
  }
  // get background image on element
  if ( this.options.background === true ) {
    this.addElementBackgroundImages( elem );
  }

  // find children
  // no non-element nodes, #143
  var nodeType = elem.nodeType;
  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
    return;
  }
  var childImgs = elem.querySelectorAll('img');
  // concat childElems to filterFound array
  for ( var i=0; i < childImgs.length; i++ ) {
    var img = childImgs[i];
    this.addImage( img );
  }

  // get child background images
  if ( typeof this.options.background == 'string' ) {
    var children = elem.querySelectorAll( this.options.background );
    for ( i=0; i < children.length; i++ ) {
      var child = children[i];
      this.addElementBackgroundImages( child );
    }
  }
};

var elementNodeTypes = {
  1: true,
  9: true,
  11: true
};

ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
    return;
  }
  // get url inside url("...")
  var reURL = /url\((['"])?(.*?)\1\)/gi;
  var matches = reURL.exec( style.backgroundImage );
  while ( matches !== null ) {
    var url = matches && matches[2];
    if ( url ) {
      this.addBackground( url, elem );
    }
    matches = reURL.exec( style.backgroundImage );
  }
};

/**
 * @param {Image} img
 */
ImagesLoaded.prototype.addImage = function( img ) {
  var loadingImage = new LoadingImage( img );
  this.images.push( loadingImage );
};

ImagesLoaded.prototype.addBackground = function( url, elem ) {
  var background = new Background( url, elem );
  this.images.push( background );
};

ImagesLoaded.prototype.check = function() {
  var _this = this;
  this.progressedCount = 0;
  this.hasAnyBroken = false;
  // complete if no images
  if ( !this.images.length ) {
    this.complete();
    return;
  }

  function onProgress( image, elem, message ) {
    // HACK - Chrome triggers event before object properties have changed. #83
    setTimeout( function() {
      _this.progress( image, elem, message );
    });
  }

  this.images.forEach( function( loadingImage ) {
    loadingImage.once( 'progress', onProgress );
    loadingImage.check();
  });
};

ImagesLoaded.prototype.progress = function( image, elem, message ) {
  this.progressedCount++;
  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
  // progress event
  this.emitEvent( 'progress', [ this, image, elem ] );
  if ( this.jqDeferred && this.jqDeferred.notify ) {
    this.jqDeferred.notify( this, image );
  }
  // check if completed
  if ( this.progressedCount == this.images.length ) {
    this.complete();
  }

  if ( this.options.debug && console ) {
    console.log( 'progress: ' + message, image, elem );
  }
};

ImagesLoaded.prototype.complete = function() {
  var eventName = this.hasAnyBroken ? 'fail' : 'done';
  this.isComplete = true;
  this.emitEvent( eventName, [ this ] );
  this.emitEvent( 'always', [ this ] );
  if ( this.jqDeferred ) {
    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
    this.jqDeferred[ jqMethod ]( this );
  }
};

// --------------------------  -------------------------- //

function LoadingImage( img ) {
  this.img = img;
}

LoadingImage.prototype = Object.create( EvEmitter.prototype );

LoadingImage.prototype.check = function() {
  // If complete is true and browser supports natural sizes,
  // try to check for image status manually.
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    // report based on naturalWidth
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    return;
  }

  // If none of the checks above matched, simulate loading on detached element.
  this.proxyImage = new Image();
  this.proxyImage.addEventListener( 'load', this );
  this.proxyImage.addEventListener( 'error', this );
  // bind to image as well for Firefox. #191
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.proxyImage.src = this.img.src;
};

LoadingImage.prototype.getIsImageComplete = function() {
  return this.img.complete && this.img.naturalWidth !== undefined;
};

LoadingImage.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.img, message ] );
};

// ----- events ----- //

// trigger specified handler for event type
LoadingImage.prototype.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

LoadingImage.prototype.onload = function() {
  this.confirm( true, 'onload' );
  this.unbindEvents();
};

LoadingImage.prototype.onerror = function() {
  this.confirm( false, 'onerror' );
  this.unbindEvents();
};

LoadingImage.prototype.unbindEvents = function() {
  this.proxyImage.removeEventListener( 'load', this );
  this.proxyImage.removeEventListener( 'error', this );
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

// -------------------------- Background -------------------------- //

function Background( url, element ) {
  this.url = url;
  this.element = element;
  this.img = new Image();
}

// inherit LoadingImage prototype
Background.prototype = Object.create( LoadingImage.prototype );

Background.prototype.check = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.img.src = this.url;
  // check if image is already complete
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    this.unbindEvents();
  }
};

Background.prototype.unbindEvents = function() {
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

Background.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.element, message ] );
};

// -------------------------- jQuery -------------------------- //

ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
  jQuery = jQuery || window.jQuery;
  if ( !jQuery ) {
    return;
  }
  // set local variable
  $ = jQuery;
  // $().imagesLoaded()
  $.fn.imagesLoaded = function( options, callback ) {
    var instance = new ImagesLoaded( this, options, callback );
    return instance.jqDeferred.promise( $(this) );
  };
};
// try making plugin
ImagesLoaded.makeJQueryPlugin();

// --------------------------  -------------------------- //

return ImagesLoaded;

});

/*!
 * Flickity imagesLoaded v2.0.0
 * enables imagesLoaded option for Flickity
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'flickity/js/index',
      'imagesloaded/imagesloaded'
    ], function( Flickity, imagesLoaded ) {
      return factory( window, Flickity, imagesLoaded );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('flickity'),
      require('imagesloaded')
    );
  } else {
    // browser global
    window.Flickity = factory(
      window,
      window.Flickity,
      window.imagesLoaded
    );
  }

}( window, function factory( window, Flickity, imagesLoaded ) {
'use strict';

Flickity.createMethods.push('_createImagesLoaded');

var proto = Flickity.prototype;

proto._createImagesLoaded = function() {
  this.on( 'activate', this.imagesLoaded );
};

proto.imagesLoaded = function() {
  if ( !this.options.imagesLoaded ) {
    return;
  }
  var _this = this;
  function onImagesLoadedProgress( instance, image ) {
    var cell = _this.getParentCell( image.img );
    _this.cellSizeChange( cell && cell.element );
    if ( !_this.options.freeScroll ) {
      _this.positionSliderAtSelected();
    }
  }
  imagesLoaded( this.slider ).on( 'progress', onImagesLoadedProgress );
};

return Flickity;

}));


/* https://github.com/WICG/focus-ring */
document.addEventListener('DOMContentLoaded', function() {
    var hadKeyboardEvent = false;
    var keyboardThrottleTimeoutID = 0;

    // These elements should always have a focus ring drawn, because they are
    // associated with switching to a keyboard modality.
    var keyboardModalityWhitelist = [ 'input:not([type])',
                                      'input[type=text]',
                                      'input[type=search]',
                                      'input[type=url]',
                                      'input[type=tel]',
                                      'input[type=email]',
                                      'input[type=password]',
                                      'input[type=number]',
                                      'input[type=date]',
                                      'input[type=month]',
                                      'input[type=week]',
                                      'input[type=time]',
                                      'input[type=datetime]',
                                      'input[type=datetime-local]',
                                      'textarea',
                                      '[role=textbox]' ].join(',');

    var matchesFunction = (function() {
        var proto = Element.prototype;
        if (proto.matches)
            return proto.matches;
        if (proto.matchesSelector)
            return proto.matchesSelector;
        if (proto.webkitMatchesSelector)
            return proto.webkitMatchesSelector;
        if (proto.mozMatchesSelector)
            return proto.mozMatchesSelector;
        if (proto.msMatchesSelector)
            return proto.msMatchesSelector;
        console.error('Couldn\'t find a matches method on Element.prototype.');
    }());

    /**
     * Computes whether the given element should automatically trigger the
     * `focus-ring` class being added, i.e. whether it should always match
     * `:focus-ring` when focused.
     * @param {Element} el
     * @return {boolean}
     */
    function focusTriggersKeyboardModality(el) {
        var triggers = false;
        if (matchesFunction) {
            triggers = matchesFunction.call(el, keyboardModalityWhitelist) &&
                       matchesFunction.call(el, ':not([readonly]');
        }
        return triggers;
    }

    /**
     * Add the `focus-ring` class to the given element if it was not added by
     * the author.
     * @param {Element} el
     */
    function addFocusRingClass(el) {
        if (typeof el.classList === 'undefined' || el.classList.contains('focus-ring'))
            return;
        el.classList.add('focus-ring');
        el.setAttribute('data-focus-ring-added', '');
    }

    /**
     * Remove the `focus-ring` class from the given element if it was not
     * originally added by the author.
     * @param {Element} el
     */
    function removeFocusRingClass(el) {
        if (typeof el.classList === 'undefined' || !el.hasAttribute('data-focus-ring-added'))
            return;
        el.classList.remove('focus-ring');
        el.removeAttribute('data-focus-ring-added')
    }

    /**
     * On `keydown`, set `hadKeyboardEvent`, to be removed 100ms later if there
     * are no further keyboard events.  The 100ms throttle handles cases where
     * focus is redirected programmatically after a keyboard event, such as
     * opening a menu or dialog.
     */
    function onKeyDown() {
        hadKeyboardEvent = true;
        // `activeElement` defaults to document.body if nothing focused,
        // so check the active element is actually focused.
        if (matchesFunction &&
            matchesFunction.call(document.activeElement, ':focus')) {
            addFocusRingClass(document.activeElement);
        }
        if (keyboardThrottleTimeoutID !== 0) {
            clearTimeout(keyboardThrottleTimeoutID);
        }
        keyboardThrottleTimeoutID = setTimeout(function() {
            hadKeyboardEvent = false;
            keyboardThrottleTimeoutID = 0;
        }, 100);
    }

    /**
     * On `focus`, add the `focus-ring` class to the target if:
     * - a keyboard event happened in the past 100ms, or
     * - the focus event target triggers "keyboard modality" and should always
     *   have a focus ring drawn.
     * @param {Event} e
     */
    function onFocus(e) {
        if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
            addFocusRingClass(e.target);
        }
    }

    /**
     * On `blur`, remove the `focus-ring` class from the target.
     * @param {Event} e
     */
    function onBlur(e) {
        removeFocusRingClass(e.target)
    }

    document.body.addEventListener('keydown', onKeyDown, true);
    document.body.addEventListener('focus', onFocus, true);
    document.body.addEventListener('blur', onBlur, true);
});

/**
 * Original Comment:
 *
 * jQuery Plugin to obtain touch gestures from iPhone, iPod Touch and iPad, should also work with Android mobile phones (not tested yet!)
 * Common usage: wipe images (left and right to show the previous or next image)
 *
 * @author Nishanth Sudharsanam
 * @version 1.2 Allowed tracking of amount of swipe which is passed to the callback.
 *
 * @author Andreas Waltl, netCU Internetagentur (http://www.netcu.de)
 * @version 1.1.1 (9th December 2010) - fix bug (older IE's had problems)
 * @version 1.1 (1st September 2010) - support wipe up and wipe down
 * @version 1.0 (15th July 2010)
 */

function ifDefined(obj, def) {
  return (typeof obj !== 'undefined') ? obj : def;
}

function touchwipe(domNode, settings) {
  settings = settings || {};

  var config = {
    min_move_x: ifDefined(settings.min_move_x, 20),
    min_move_y: ifDefined(settings.min_move_y, 20),
    wipeLeft: settings.wipeLeft || function() {},
    wipeRight: settings.wipeRight || function() {},
    wipeUp: settings.wipeUp || function() {},
    wipeDown: settings.wipeDown || function() {},
    preventDefaultEvents: ifDefined(settings.preventDefaultEvents, true)
  };

  var startX;
  var startY;
  var isMoving = false;

  function cancelTouch() {
    domNode.removeEventListener('touchmove', onTouchMove);
    startX = null;
    isMoving = false;
  }

  function onTouchMove(e) {
    if (config.preventDefaultEvents) {
      e.preventDefault();
    }
    if (isMoving) {
      var x = e.touches[0].pageX;
      var y = e.touches[0].pageY;
      var dx = startX - x;
      var dy = startY - y;
      if (Math.abs(dx) >= config.min_move_x) {
        cancelTouch();
        if (dx > 0) {
          config.wipeLeft(e);
        }
        else {
          config.wipeRight(e);
        }
      }
      else if (Math.abs(dy) >= config.min_move_y) {
        cancelTouch();
        if (dy > 0) {
          config.wipeDown(e);
        }
        else {
          config.wipeUp(e);
        }
      }
    }
  }

  function onTouchStart(e) {
    if (e.touches.length === 1) {
      startX = e.touches[0].pageX;
      startY = e.touches[0].pageY;
      isMoving = true;
      domNode.addEventListener('touchmove', onTouchMove);
    }
  }

  domNode.addEventListener('touchstart', onTouchStart);

  return {
    unbind: function() {
      domNode.removeEventListener('touchstart', onTouchStart);
    }
  };
};
